import { ReactComponent as ForwardRef } from './svgs/0-plus.svg.js';
import { ReactComponent as ForwardRef$8 } from './svgs/3-plus.svg.js';
import { ReactComponent as ForwardRef$a } from './svgs/6-plus.svg.js';
import { ReactComponent as ForwardRef$1 } from './svgs/10-plus.svg.js';
import { ReactComponent as ForwardRef$2 } from './svgs/12-plus.svg.js';
import { ReactComponent as ForwardRef$3 } from './svgs/13-plus.svg.js';
import { ReactComponent as ForwardRef$4 } from './svgs/16-plus.svg.js';
import { ReactComponent as ForwardRef$5 } from './svgs/17-plus.svg.js';
import { ReactComponent as ForwardRef$6 } from './svgs/18-plus.svg.js';
import { ReactComponent as ForwardRef$7 } from './svgs/21-plus.svg.js';
import { ReactComponent as ForwardRef$9 } from './svgs/500px.svg.js';
import { ReactComponent as ForwardRef$b } from './svgs/abacus.svg.js';
import { ReactComponent as ForwardRef$c } from './svgs/accessible-icon-alt.svg.js';
import { ReactComponent as ForwardRef$d } from './svgs/adjust-alt.svg.js';
import { ReactComponent as ForwardRef$e } from './svgs/adjust-circle.svg.js';
import { ReactComponent as ForwardRef$f } from './svgs/adjust-half.svg.js';
import { ReactComponent as ForwardRef$g } from './svgs/adjust.svg.js';
import { ReactComponent as ForwardRef$h } from './svgs/adobe-alt.svg.js';
import { ReactComponent as ForwardRef$i } from './svgs/adobe.svg.js';
import { ReactComponent as ForwardRef$j } from './svgs/airplay.svg.js';
import { ReactComponent as ForwardRef$k } from './svgs/align-alt.svg.js';
import { ReactComponent as ForwardRef$l } from './svgs/align-center-alt.svg.js';
import { ReactComponent as ForwardRef$m } from './svgs/align-center-h.svg.js';
import { ReactComponent as ForwardRef$n } from './svgs/align-center-justify.svg.js';
import { ReactComponent as ForwardRef$o } from './svgs/align-center-v.svg.js';
import { ReactComponent as ForwardRef$p } from './svgs/align-center.svg.js';
import { ReactComponent as ForwardRef$q } from './svgs/align-justify.svg.js';
import { ReactComponent as ForwardRef$r } from './svgs/align-left-justify.svg.js';
import { ReactComponent as ForwardRef$s } from './svgs/align-left.svg.js';
import { ReactComponent as ForwardRef$t } from './svgs/align-letter-right.svg.js';
import { ReactComponent as ForwardRef$u } from './svgs/align-right-justify.svg.js';
import { ReactComponent as ForwardRef$v } from './svgs/align-right.svg.js';
import { ReactComponent as ForwardRef$w } from './svgs/align.svg.js';
import { ReactComponent as ForwardRef$x } from './svgs/amazon.svg.js';
import { ReactComponent as ForwardRef$y } from './svgs/ambulance.svg.js';
import { ReactComponent as ForwardRef$z } from './svgs/analysis.svg.js';
import { ReactComponent as ForwardRef$A } from './svgs/analytics.svg.js';
import { ReactComponent as ForwardRef$B } from './svgs/anchor.svg.js';
import { ReactComponent as ForwardRef$C } from './svgs/android-alt.svg.js';
import { ReactComponent as ForwardRef$D } from './svgs/android-phone-slash.svg.js';
import { ReactComponent as ForwardRef$E } from './svgs/android.svg.js';
import { ReactComponent as ForwardRef$F } from './svgs/angle-double-down.svg.js';
import { ReactComponent as ForwardRef$G } from './svgs/angle-double-left.svg.js';
import { ReactComponent as ForwardRef$H } from './svgs/angle-double-right.svg.js';
import { ReactComponent as ForwardRef$I } from './svgs/angle-double-up.svg.js';
import { ReactComponent as ForwardRef$J } from './svgs/angle-down.svg.js';
import { ReactComponent as ForwardRef$K } from './svgs/angle-left-b.svg.js';
import { ReactComponent as ForwardRef$L } from './svgs/angle-left.svg.js';
import { ReactComponent as ForwardRef$M } from './svgs/angle-right-b.svg.js';
import { ReactComponent as ForwardRef$N } from './svgs/angle-right.svg.js';
import { ReactComponent as ForwardRef$O } from './svgs/angle-up.svg.js';
import { ReactComponent as ForwardRef$P } from './svgs/angry.svg.js';
import { ReactComponent as ForwardRef$Q } from './svgs/ankh.svg.js';
import { ReactComponent as ForwardRef$R } from './svgs/annoyed-alt.svg.js';
import { ReactComponent as ForwardRef$S } from './svgs/annoyed.svg.js';
import { ReactComponent as ForwardRef$T } from './svgs/apple-alt.svg.js';
import { ReactComponent as ForwardRef$U } from './svgs/apple.svg.js';
import { ReactComponent as ForwardRef$V } from './svgs/apps.svg.js';
import { ReactComponent as ForwardRef$W } from './svgs/archive-alt.svg.js';
import { ReactComponent as ForwardRef$X } from './svgs/archive.svg.js';
import { ReactComponent as ForwardRef$Y } from './svgs/archway.svg.js';
import { ReactComponent as ForwardRef$Z } from './svgs/arrow-break.svg.js';
import { ReactComponent as ForwardRef$_ } from './svgs/arrow-circle-down.svg.js';
import { ReactComponent as ForwardRef$$ } from './svgs/arrow-circle-left.svg.js';
import { ReactComponent as ForwardRef$10 } from './svgs/arrow-circle-right.svg.js';
import { ReactComponent as ForwardRef$11 } from './svgs/arrow-circle-up.svg.js';
import { ReactComponent as ForwardRef$12 } from './svgs/arrow-compress-h.svg.js';
import { ReactComponent as ForwardRef$13 } from './svgs/arrow-down-left.svg.js';
import { ReactComponent as ForwardRef$14 } from './svgs/arrow-down-right.svg.js';
import { ReactComponent as ForwardRef$15 } from './svgs/arrow-down.svg.js';
import { ReactComponent as ForwardRef$16 } from './svgs/arrow-from-right.svg.js';
import { ReactComponent as ForwardRef$17 } from './svgs/arrow-from-top.svg.js';
import { ReactComponent as ForwardRef$18 } from './svgs/arrow-growth.svg.js';
import { ReactComponent as ForwardRef$19 } from './svgs/arrow-left.svg.js';
import { ReactComponent as ForwardRef$1a } from './svgs/arrow-random.svg.js';
import { ReactComponent as ForwardRef$1b } from './svgs/arrow-resize-diagonal.svg.js';
import { ReactComponent as ForwardRef$1c } from './svgs/arrow-right.svg.js';
import { ReactComponent as ForwardRef$1d } from './svgs/arrow-to-bottom.svg.js';
import { ReactComponent as ForwardRef$1e } from './svgs/arrow-to-right.svg.js';
import { ReactComponent as ForwardRef$1f } from './svgs/arrow-up-left.svg.js';
import { ReactComponent as ForwardRef$1g } from './svgs/arrow-up-right.svg.js';
import { ReactComponent as ForwardRef$1h } from './svgs/arrow-up.svg.js';
import { ReactComponent as ForwardRef$1i } from './svgs/arrow.svg.js';
import { ReactComponent as ForwardRef$1j } from './svgs/arrows-h-alt.svg.js';
import { ReactComponent as ForwardRef$1k } from './svgs/arrows-h.svg.js';
import { ReactComponent as ForwardRef$1l } from './svgs/arrows-left-down.svg.js';
import { ReactComponent as ForwardRef$1m } from './svgs/arrows-maximize.svg.js';
import { ReactComponent as ForwardRef$1n } from './svgs/arrows-merge.svg.js';
import { ReactComponent as ForwardRef$1o } from './svgs/arrows-resize-h.svg.js';
import { ReactComponent as ForwardRef$1p } from './svgs/arrows-resize-v.svg.js';
import { ReactComponent as ForwardRef$1q } from './svgs/arrows-resize.svg.js';
import { ReactComponent as ForwardRef$1r } from './svgs/arrows-right-down.svg.js';
import { ReactComponent as ForwardRef$1s } from './svgs/arrows-shrink-h.svg.js';
import { ReactComponent as ForwardRef$1t } from './svgs/arrows-shrink-v.svg.js';
import { ReactComponent as ForwardRef$1u } from './svgs/arrows-up-right.svg.js';
import { ReactComponent as ForwardRef$1v } from './svgs/arrows-v-alt.svg.js';
import { ReactComponent as ForwardRef$1w } from './svgs/arrows-v.svg.js';
import { ReactComponent as ForwardRef$1x } from './svgs/assistive-listening-systems.svg.js';
import { ReactComponent as ForwardRef$1y } from './svgs/asterisk.svg.js';
import { ReactComponent as ForwardRef$1z } from './svgs/at.svg.js';
import { ReactComponent as ForwardRef$1A } from './svgs/atom.svg.js';
import { ReactComponent as ForwardRef$1B } from './svgs/auto-flash.svg.js';
import { ReactComponent as ForwardRef$1C } from './svgs/award-alt.svg.js';
import { ReactComponent as ForwardRef$1D } from './svgs/award.svg.js';
import { ReactComponent as ForwardRef$1E } from './svgs/baby-carriage.svg.js';
import { ReactComponent as ForwardRef$1F } from './svgs/backpack.svg.js';
import { ReactComponent as ForwardRef$1G } from './svgs/backspace.svg.js';
import { ReactComponent as ForwardRef$1H } from './svgs/backward.svg.js';
import { ReactComponent as ForwardRef$1I } from './svgs/bag-alt.svg.js';
import { ReactComponent as ForwardRef$1J } from './svgs/bag-slash.svg.js';
import { ReactComponent as ForwardRef$1K } from './svgs/bag.svg.js';
import { ReactComponent as ForwardRef$1L } from './svgs/balance-scale.svg.js';
import { ReactComponent as ForwardRef$1M } from './svgs/ban.svg.js';
import { ReactComponent as ForwardRef$1N } from './svgs/band-aid.svg.js';
import { ReactComponent as ForwardRef$1O } from './svgs/bars.svg.js';
import { ReactComponent as ForwardRef$1P } from './svgs/baseball-ball.svg.js';
import { ReactComponent as ForwardRef$1Q } from './svgs/basketball-hoop.svg.js';
import { ReactComponent as ForwardRef$1R } from './svgs/basketball.svg.js';
import { ReactComponent as ForwardRef$1S } from './svgs/bath.svg.js';
import { ReactComponent as ForwardRef$1T } from './svgs/battery-bolt.svg.js';
import { ReactComponent as ForwardRef$1U } from './svgs/battery-empty.svg.js';
import { ReactComponent as ForwardRef$1V } from './svgs/bed-double.svg.js';
import { ReactComponent as ForwardRef$1W } from './svgs/bed.svg.js';
import { ReactComponent as ForwardRef$1X } from './svgs/behance-alt.svg.js';
import { ReactComponent as ForwardRef$1Y } from './svgs/behance.svg.js';
import { ReactComponent as ForwardRef$1Z } from './svgs/bell-school.svg.js';
import { ReactComponent as ForwardRef$1_ } from './svgs/bell-slash.svg.js';
import { ReactComponent as ForwardRef$1$ } from './svgs/bell.svg.js';
import { ReactComponent as ForwardRef$20 } from './svgs/bill.svg.js';
import { ReactComponent as ForwardRef$21 } from './svgs/bing.svg.js';
import { ReactComponent as ForwardRef$22 } from './svgs/bitcoin-alt.svg.js';
import { ReactComponent as ForwardRef$23 } from './svgs/bitcoin-circle.svg.js';
import { ReactComponent as ForwardRef$24 } from './svgs/bitcoin-sign.svg.js';
import { ReactComponent as ForwardRef$25 } from './svgs/bitcoin.svg.js';
import { ReactComponent as ForwardRef$26 } from './svgs/black-berry.svg.js';
import { ReactComponent as ForwardRef$27 } from './svgs/blogger-alt.svg.js';
import { ReactComponent as ForwardRef$28 } from './svgs/blogger.svg.js';
import { ReactComponent as ForwardRef$29 } from './svgs/bluetooth-b.svg.js';
import { ReactComponent as ForwardRef$2a } from './svgs/bold.svg.js';
import { ReactComponent as ForwardRef$2b } from './svgs/bolt-alt.svg.js';
import { ReactComponent as ForwardRef$2c } from './svgs/bolt-slash.svg.js';
import { ReactComponent as ForwardRef$2d } from './svgs/bolt.svg.js';
import { ReactComponent as ForwardRef$2e } from './svgs/book-alt.svg.js';
import { ReactComponent as ForwardRef$2f } from './svgs/book-medical.svg.js';
import { ReactComponent as ForwardRef$2g } from './svgs/book-open.svg.js';
import { ReactComponent as ForwardRef$2h } from './svgs/book-reader.svg.js';
import { ReactComponent as ForwardRef$2i } from './svgs/book.svg.js';
import { ReactComponent as ForwardRef$2j } from './svgs/bookmark-full.svg.js';
import { ReactComponent as ForwardRef$2k } from './svgs/bookmark.svg.js';
import { ReactComponent as ForwardRef$2l } from './svgs/books.svg.js';
import { ReactComponent as ForwardRef$2m } from './svgs/boombox.svg.js';
import { ReactComponent as ForwardRef$2n } from './svgs/border-alt.svg.js';
import { ReactComponent as ForwardRef$2o } from './svgs/border-bottom.svg.js';
import { ReactComponent as ForwardRef$2p } from './svgs/border-clear.svg.js';
import { ReactComponent as ForwardRef$2q } from './svgs/border-horizontal.svg.js';
import { ReactComponent as ForwardRef$2r } from './svgs/border-inner.svg.js';
import { ReactComponent as ForwardRef$2s } from './svgs/border-left.svg.js';
import { ReactComponent as ForwardRef$2t } from './svgs/border-out.svg.js';
import { ReactComponent as ForwardRef$2u } from './svgs/border-right.svg.js';
import { ReactComponent as ForwardRef$2v } from './svgs/border-top.svg.js';
import { ReactComponent as ForwardRef$2w } from './svgs/border-vertical.svg.js';
import { ReactComponent as ForwardRef$2x } from './svgs/bowling-ball.svg.js';
import { ReactComponent as ForwardRef$2y } from './svgs/box.svg.js';
import { ReactComponent as ForwardRef$2z } from './svgs/brackets-curly.svg.js';
import { ReactComponent as ForwardRef$2A } from './svgs/brain.svg.js';
import { ReactComponent as ForwardRef$2B } from './svgs/briefcase-alt.svg.js';
import { ReactComponent as ForwardRef$2C } from './svgs/briefcase.svg.js';
import { ReactComponent as ForwardRef$2D } from './svgs/bright.svg.js';
import { ReactComponent as ForwardRef$2E } from './svgs/brightness-empty.svg.js';
import { ReactComponent as ForwardRef$2F } from './svgs/brightness-half.svg.js';
import { ReactComponent as ForwardRef$2G } from './svgs/brightness-low.svg.js';
import { ReactComponent as ForwardRef$2H } from './svgs/brightness-minus.svg.js';
import { ReactComponent as ForwardRef$2I } from './svgs/brightness-plus.svg.js';
import { ReactComponent as ForwardRef$2J } from './svgs/brightness.svg.js';
import { ReactComponent as ForwardRef$2K } from './svgs/bring-bottom.svg.js';
import { ReactComponent as ForwardRef$2L } from './svgs/bring-front.svg.js';
import { ReactComponent as ForwardRef$2M } from './svgs/browser.svg.js';
import { ReactComponent as ForwardRef$2N } from './svgs/brush-alt.svg.js';
import { ReactComponent as ForwardRef$2O } from './svgs/bug.svg.js';
import { ReactComponent as ForwardRef$2P } from './svgs/building.svg.js';
import { ReactComponent as ForwardRef$2Q } from './svgs/bullet.svg.js';
import { ReactComponent as ForwardRef$2R } from './svgs/bullseye.svg.js';
import { ReactComponent as ForwardRef$2S } from './svgs/bus-alt.svg.js';
import { ReactComponent as ForwardRef$2T } from './svgs/bus-school.svg.js';
import { ReactComponent as ForwardRef$2U } from './svgs/bus.svg.js';
import { ReactComponent as ForwardRef$2V } from './svgs/calculator-alt.svg.js';
import { ReactComponent as ForwardRef$2W } from './svgs/calculator.svg.js';
import { ReactComponent as ForwardRef$2X } from './svgs/calendar-alt.svg.js';
import { ReactComponent as ForwardRef$2Y } from './svgs/calendar-slash.svg.js';
import { ReactComponent as ForwardRef$2Z } from './svgs/calender.svg.js';
import { ReactComponent as ForwardRef$2_ } from './svgs/calling.svg.js';
import { ReactComponent as ForwardRef$2$ } from './svgs/camera-change.svg.js';
import { ReactComponent as ForwardRef$30 } from './svgs/camera-plus.svg.js';
import { ReactComponent as ForwardRef$31 } from './svgs/camera-slash.svg.js';
import { ReactComponent as ForwardRef$32 } from './svgs/camera.svg.js';
import { ReactComponent as ForwardRef$33 } from './svgs/cancel.svg.js';
import { ReactComponent as ForwardRef$34 } from './svgs/capsule.svg.js';
import { ReactComponent as ForwardRef$35 } from './svgs/capture.svg.js';
import { ReactComponent as ForwardRef$36 } from './svgs/car-sideview.svg.js';
import { ReactComponent as ForwardRef$37 } from './svgs/car-slash.svg.js';
import { ReactComponent as ForwardRef$38 } from './svgs/car-wash.svg.js';
import { ReactComponent as ForwardRef$39 } from './svgs/car.svg.js';
import { ReactComponent as ForwardRef$3a } from './svgs/card-atm.svg.js';
import { ReactComponent as ForwardRef$3b } from './svgs/caret-right.svg.js';
import { ReactComponent as ForwardRef$3c } from './svgs/cell.svg.js';
import { ReactComponent as ForwardRef$3d } from './svgs/celsius.svg.js';
import { ReactComponent as ForwardRef$3e } from './svgs/channel-add.svg.js';
import { ReactComponent as ForwardRef$3f } from './svgs/channel.svg.js';
import { ReactComponent as ForwardRef$3g } from './svgs/chart-bar-alt.svg.js';
import { ReactComponent as ForwardRef$3h } from './svgs/chart-bar.svg.js';
import { ReactComponent as ForwardRef$3i } from './svgs/chart-down.svg.js';
import { ReactComponent as ForwardRef$3j } from './svgs/chart-growth-alt.svg.js';
import { ReactComponent as ForwardRef$3k } from './svgs/chart-growth.svg.js';
import { ReactComponent as ForwardRef$3l } from './svgs/chart-line.svg.js';
import { ReactComponent as ForwardRef$3m } from './svgs/chart-pie-alt.svg.js';
import { ReactComponent as ForwardRef$3n } from './svgs/chart-pie.svg.js';
import { ReactComponent as ForwardRef$3o } from './svgs/chart.svg.js';
import { ReactComponent as ForwardRef$3p } from './svgs/chat-bubble-user.svg.js';
import { ReactComponent as ForwardRef$3q } from './svgs/chat-info.svg.js';
import { ReactComponent as ForwardRef$3r } from './svgs/chat.svg.js';
import { ReactComponent as ForwardRef$3s } from './svgs/check-circle.svg.js';
import { ReactComponent as ForwardRef$3t } from './svgs/check-square.svg.js';
import { ReactComponent as ForwardRef$3u } from './svgs/check.svg.js';
import { ReactComponent as ForwardRef$3v } from './svgs/circle-layer.svg.js';
import { ReactComponent as ForwardRef$3w } from './svgs/circle.svg.js';
import { ReactComponent as ForwardRef$3x } from './svgs/circuit.svg.js';
import { ReactComponent as ForwardRef$3y } from './svgs/clapper-board.svg.js';
import { ReactComponent as ForwardRef$3z } from './svgs/clinic-medical.svg.js';
import { ReactComponent as ForwardRef$3A } from './svgs/clipboard-alt.svg.js';
import { ReactComponent as ForwardRef$3B } from './svgs/clipboard-blank.svg.js';
import { ReactComponent as ForwardRef$3C } from './svgs/clipboard-notes.svg.js';
import { ReactComponent as ForwardRef$3D } from './svgs/clipboard.svg.js';
import { ReactComponent as ForwardRef$3E } from './svgs/clock-eight.svg.js';
import { ReactComponent as ForwardRef$3F } from './svgs/clock-five.svg.js';
import { ReactComponent as ForwardRef$3G } from './svgs/clock-nine.svg.js';
import { ReactComponent as ForwardRef$3H } from './svgs/clock-seven.svg.js';
import { ReactComponent as ForwardRef$3I } from './svgs/clock-ten.svg.js';
import { ReactComponent as ForwardRef$3J } from './svgs/clock-three.svg.js';
import { ReactComponent as ForwardRef$3K } from './svgs/clock-two.svg.js';
import { ReactComponent as ForwardRef$3L } from './svgs/clock.svg.js';
import { ReactComponent as ForwardRef$3M } from './svgs/closed-captioning-slash.svg.js';
import { ReactComponent as ForwardRef$3N } from './svgs/closed-captioning.svg.js';
import { ReactComponent as ForwardRef$3O } from './svgs/cloud-block.svg.js';
import { ReactComponent as ForwardRef$3P } from './svgs/cloud-bookmark.svg.js';
import { ReactComponent as ForwardRef$3Q } from './svgs/cloud-check.svg.js';
import { ReactComponent as ForwardRef$3R } from './svgs/cloud-computing.svg.js';
import { ReactComponent as ForwardRef$3S } from './svgs/cloud-data-connection.svg.js';
import { ReactComponent as ForwardRef$3T } from './svgs/cloud-database-tree.svg.js';
import { ReactComponent as ForwardRef$3U } from './svgs/cloud-download.svg.js';
import { ReactComponent as ForwardRef$3V } from './svgs/cloud-drizzle.svg.js';
import { ReactComponent as ForwardRef$3W } from './svgs/cloud-exclamation.svg.js';
import { ReactComponent as ForwardRef$3X } from './svgs/cloud-hail.svg.js';
import { ReactComponent as ForwardRef$3Y } from './svgs/cloud-heart.svg.js';
import { ReactComponent as ForwardRef$3Z } from './svgs/cloud-info.svg.js';
import { ReactComponent as ForwardRef$3_ } from './svgs/cloud-lock.svg.js';
import { ReactComponent as ForwardRef$3$ } from './svgs/cloud-meatball.svg.js';
import { ReactComponent as ForwardRef$40 } from './svgs/cloud-moon-hail.svg.js';
import { ReactComponent as ForwardRef$41 } from './svgs/cloud-moon-meatball.svg.js';
import { ReactComponent as ForwardRef$42 } from './svgs/cloud-moon-rain.svg.js';
import { ReactComponent as ForwardRef$43 } from './svgs/cloud-moon-showers.svg.js';
import { ReactComponent as ForwardRef$44 } from './svgs/cloud-moon.svg.js';
import { ReactComponent as ForwardRef$45 } from './svgs/cloud-question.svg.js';
import { ReactComponent as ForwardRef$46 } from './svgs/cloud-rain-sun.svg.js';
import { ReactComponent as ForwardRef$47 } from './svgs/cloud-rain.svg.js';
import { ReactComponent as ForwardRef$48 } from './svgs/cloud-redo.svg.js';
import { ReactComponent as ForwardRef$49 } from './svgs/cloud-share.svg.js';
import { ReactComponent as ForwardRef$4a } from './svgs/cloud-shield.svg.js';
import { ReactComponent as ForwardRef$4b } from './svgs/cloud-showers-alt.svg.js';
import { ReactComponent as ForwardRef$4c } from './svgs/cloud-showers-heavy.svg.js';
import { ReactComponent as ForwardRef$4d } from './svgs/cloud-showers.svg.js';
import { ReactComponent as ForwardRef$4e } from './svgs/cloud-slash.svg.js';
import { ReactComponent as ForwardRef$4f } from './svgs/cloud-sun-hail.svg.js';
import { ReactComponent as ForwardRef$4g } from './svgs/cloud-sun-meatball.svg.js';
import { ReactComponent as ForwardRef$4h } from './svgs/cloud-sun-rain-alt.svg.js';
import { ReactComponent as ForwardRef$4i } from './svgs/cloud-sun-rain.svg.js';
import { ReactComponent as ForwardRef$4j } from './svgs/cloud-sun-tear.svg.js';
import { ReactComponent as ForwardRef$4k } from './svgs/cloud-sun.svg.js';
import { ReactComponent as ForwardRef$4l } from './svgs/cloud-times.svg.js';
import { ReactComponent as ForwardRef$4m } from './svgs/cloud-unlock.svg.js';
import { ReactComponent as ForwardRef$4n } from './svgs/cloud-upload.svg.js';
import { ReactComponent as ForwardRef$4o } from './svgs/cloud-wifi.svg.js';
import { ReactComponent as ForwardRef$4p } from './svgs/cloud-wind.svg.js';
import { ReactComponent as ForwardRef$4q } from './svgs/cloud.svg.js';
import { ReactComponent as ForwardRef$4r } from './svgs/clouds.svg.js';
import { ReactComponent as ForwardRef$4s } from './svgs/club.svg.js';
import { ReactComponent as ForwardRef$4t } from './svgs/code-branch.svg.js';
import { ReactComponent as ForwardRef$4u } from './svgs/coffee.svg.js';
import { ReactComponent as ForwardRef$4v } from './svgs/cog.svg.js';
import { ReactComponent as ForwardRef$4w } from './svgs/coins.svg.js';
import { ReactComponent as ForwardRef$4x } from './svgs/columns.svg.js';
import { ReactComponent as ForwardRef$4y } from './svgs/comment-add.svg.js';
import { ReactComponent as ForwardRef$4z } from './svgs/comment-alt-block.svg.js';
import { ReactComponent as ForwardRef$4A } from './svgs/comment-alt-chart-lines.svg.js';
import { ReactComponent as ForwardRef$4B } from './svgs/comment-alt-check.svg.js';
import { ReactComponent as ForwardRef$4C } from './svgs/comment-alt-dots.svg.js';
import { ReactComponent as ForwardRef$4D } from './svgs/comment-alt-download.svg.js';
import { ReactComponent as ForwardRef$4E } from './svgs/comment-alt-edit.svg.js';
import { ReactComponent as ForwardRef$4F } from './svgs/comment-alt-exclamation.svg.js';
import { ReactComponent as ForwardRef$4G } from './svgs/comment-alt-heart.svg.js';
import { ReactComponent as ForwardRef$4H } from './svgs/comment-alt-image.svg.js';
import { ReactComponent as ForwardRef$4I } from './svgs/comment-alt-info.svg.js';
import { ReactComponent as ForwardRef$4J } from './svgs/comment-alt-lines.svg.js';
import { ReactComponent as ForwardRef$4K } from './svgs/comment-alt-lock.svg.js';
import { ReactComponent as ForwardRef$4L } from './svgs/comment-alt-medical.svg.js';
import { ReactComponent as ForwardRef$4M } from './svgs/comment-alt-message.svg.js';
import { ReactComponent as ForwardRef$4N } from './svgs/comment-alt-notes.svg.js';
import { ReactComponent as ForwardRef$4O } from './svgs/comment-alt-plus.svg.js';
import { ReactComponent as ForwardRef$4P } from './svgs/comment-alt-question.svg.js';
import { ReactComponent as ForwardRef$4Q } from './svgs/comment-alt-redo.svg.js';
import { ReactComponent as ForwardRef$4R } from './svgs/comment-alt-search.svg.js';
import { ReactComponent as ForwardRef$4S } from './svgs/comment-alt-share.svg.js';
import { ReactComponent as ForwardRef$4T } from './svgs/comment-alt-shield.svg.js';
import { ReactComponent as ForwardRef$4U } from './svgs/comment-alt-slash.svg.js';
import { ReactComponent as ForwardRef$4V } from './svgs/comment-alt-upload.svg.js';
import { ReactComponent as ForwardRef$4W } from './svgs/comment-alt-verify.svg.js';
import { ReactComponent as ForwardRef$4X } from './svgs/comment-alt.svg.js';
import { ReactComponent as ForwardRef$4Y } from './svgs/comment-block.svg.js';
import { ReactComponent as ForwardRef$4Z } from './svgs/comment-chart-line.svg.js';
import { ReactComponent as ForwardRef$4_ } from './svgs/comment-check.svg.js';
import { ReactComponent as ForwardRef$4$ } from './svgs/comment-dots.svg.js';
import { ReactComponent as ForwardRef$50 } from './svgs/comment-download.svg.js';
import { ReactComponent as ForwardRef$51 } from './svgs/comment-edit.svg.js';
import { ReactComponent as ForwardRef$52 } from './svgs/comment-exclamation.svg.js';
import { ReactComponent as ForwardRef$53 } from './svgs/comment-heart.svg.js';
import { ReactComponent as ForwardRef$54 } from './svgs/comment-image.svg.js';
import { ReactComponent as ForwardRef$55 } from './svgs/comment-info-alt.svg.js';
import { ReactComponent as ForwardRef$56 } from './svgs/comment-info.svg.js';
import { ReactComponent as ForwardRef$57 } from './svgs/comment-lines.svg.js';
import { ReactComponent as ForwardRef$58 } from './svgs/comment-lock.svg.js';
import { ReactComponent as ForwardRef$59 } from './svgs/comment-medical.svg.js';
import { ReactComponent as ForwardRef$5a } from './svgs/comment-message.svg.js';
import { ReactComponent as ForwardRef$5b } from './svgs/comment-notes.svg.js';
import { ReactComponent as ForwardRef$5c } from './svgs/comment-plus.svg.js';
import { ReactComponent as ForwardRef$5d } from './svgs/comment-question.svg.js';
import { ReactComponent as ForwardRef$5e } from './svgs/comment-redo.svg.js';
import { ReactComponent as ForwardRef$5f } from './svgs/comment-search.svg.js';
import { ReactComponent as ForwardRef$5g } from './svgs/comment-share.svg.js';
import { ReactComponent as ForwardRef$5h } from './svgs/comment-shield.svg.js';
import { ReactComponent as ForwardRef$5i } from './svgs/comment-slash.svg.js';
import { ReactComponent as ForwardRef$5j } from './svgs/comment-upload.svg.js';
import { ReactComponent as ForwardRef$5k } from './svgs/comment-verify.svg.js';
import { ReactComponent as ForwardRef$5l } from './svgs/comment.svg.js';
import { ReactComponent as ForwardRef$5m } from './svgs/comments-alt.svg.js';
import { ReactComponent as ForwardRef$5n } from './svgs/comments.svg.js';
import { ReactComponent as ForwardRef$5o } from './svgs/compact-disc.svg.js';
import { ReactComponent as ForwardRef$5p } from './svgs/comparison.svg.js';
import { ReactComponent as ForwardRef$5q } from './svgs/compass.svg.js';
import { ReactComponent as ForwardRef$5r } from './svgs/compress-alt-left.svg.js';
import { ReactComponent as ForwardRef$5s } from './svgs/compress-alt.svg.js';
import { ReactComponent as ForwardRef$5t } from './svgs/compress-arrows.svg.js';
import { ReactComponent as ForwardRef$5u } from './svgs/compress-lines.svg.js';
import { ReactComponent as ForwardRef$5v } from './svgs/compress-point.svg.js';
import { ReactComponent as ForwardRef$5w } from './svgs/compress-v.svg.js';
import { ReactComponent as ForwardRef$5x } from './svgs/compress.svg.js';
import { ReactComponent as ForwardRef$5y } from './svgs/confused.svg.js';
import { ReactComponent as ForwardRef$5z } from './svgs/constructor.svg.js';
import { ReactComponent as ForwardRef$5A } from './svgs/copy-alt.svg.js';
import { ReactComponent as ForwardRef$5B } from './svgs/copy-landscape.svg.js';
import { ReactComponent as ForwardRef$5C } from './svgs/copy.svg.js';
import { ReactComponent as ForwardRef$5D } from './svgs/copyright.svg.js';
import { ReactComponent as ForwardRef$5E } from './svgs/corner-down-left.svg.js';
import { ReactComponent as ForwardRef$5F } from './svgs/corner-down-right-alt.svg.js';
import { ReactComponent as ForwardRef$5G } from './svgs/corner-down-right.svg.js';
import { ReactComponent as ForwardRef$5H } from './svgs/corner-left-down.svg.js';
import { ReactComponent as ForwardRef$5I } from './svgs/corner-right-down.svg.js';
import { ReactComponent as ForwardRef$5J } from './svgs/corner-up-left-alt.svg.js';
import { ReactComponent as ForwardRef$5K } from './svgs/corner-up-left.svg.js';
import { ReactComponent as ForwardRef$5L } from './svgs/corner-up-right-alt.svg.js';
import { ReactComponent as ForwardRef$5M } from './svgs/corner-up-right.svg.js';
import { ReactComponent as ForwardRef$5N } from './svgs/coronavirus.svg.js';
import { ReactComponent as ForwardRef$5O } from './svgs/create-dashboard.svg.js';
import { ReactComponent as ForwardRef$5P } from './svgs/creative-commons-pd.svg.js';
import { ReactComponent as ForwardRef$5Q } from './svgs/credit-card-search.svg.js';
import { ReactComponent as ForwardRef$5R } from './svgs/credit-card.svg.js';
import { ReactComponent as ForwardRef$5S } from './svgs/crockery.svg.js';
import { ReactComponent as ForwardRef$5T } from './svgs/crop-alt-rotate-left.svg.js';
import { ReactComponent as ForwardRef$5U } from './svgs/crop-alt-rotate-right.svg.js';
import { ReactComponent as ForwardRef$5V } from './svgs/crop-alt.svg.js';
import { ReactComponent as ForwardRef$5W } from './svgs/crosshair-alt.svg.js';
import { ReactComponent as ForwardRef$5X } from './svgs/crosshair.svg.js';
import { ReactComponent as ForwardRef$5Y } from './svgs/crosshairs.svg.js';
import { ReactComponent as ForwardRef$5Z } from './svgs/css3-simple.svg.js';
import { ReactComponent as ForwardRef$5_ } from './svgs/cube.svg.js';
import { ReactComponent as ForwardRef$5$ } from './svgs/dashboard.svg.js';
import { ReactComponent as ForwardRef$60 } from './svgs/data-sharing.svg.js';
import { ReactComponent as ForwardRef$61 } from './svgs/database-alt.svg.js';
import { ReactComponent as ForwardRef$62 } from './svgs/database.svg.js';
import { ReactComponent as ForwardRef$63 } from './svgs/desert.svg.js';
import { ReactComponent as ForwardRef$64 } from './svgs/desktop-alt-slash.svg.js';
import { ReactComponent as ForwardRef$65 } from './svgs/desktop-alt.svg.js';
import { ReactComponent as ForwardRef$66 } from './svgs/desktop-cloud-alt.svg.js';
import { ReactComponent as ForwardRef$67 } from './svgs/desktop-slash.svg.js';
import { ReactComponent as ForwardRef$68 } from './svgs/desktop.svg.js';
import { ReactComponent as ForwardRef$69 } from './svgs/dialpad-alt.svg.js';
import { ReactComponent as ForwardRef$6a } from './svgs/dialpad.svg.js';
import { ReactComponent as ForwardRef$6b } from './svgs/diamond.svg.js';
import { ReactComponent as ForwardRef$6c } from './svgs/diary-alt.svg.js';
import { ReactComponent as ForwardRef$6d } from './svgs/diary.svg.js';
import { ReactComponent as ForwardRef$6e } from './svgs/dice-five.svg.js';
import { ReactComponent as ForwardRef$6f } from './svgs/dice-four.svg.js';
import { ReactComponent as ForwardRef$6g } from './svgs/dice-one.svg.js';
import { ReactComponent as ForwardRef$6h } from './svgs/dice-six.svg.js';
import { ReactComponent as ForwardRef$6i } from './svgs/dice-three.svg.js';
import { ReactComponent as ForwardRef$6j } from './svgs/dice-two.svg.js';
import { ReactComponent as ForwardRef$6k } from './svgs/direction.svg.js';
import { ReactComponent as ForwardRef$6l } from './svgs/directions.svg.js';
import { ReactComponent as ForwardRef$6m } from './svgs/discord.svg.js';
import { ReactComponent as ForwardRef$6n } from './svgs/dizzy-meh.svg.js';
import { ReactComponent as ForwardRef$6o } from './svgs/dna.svg.js';
import { ReactComponent as ForwardRef$6p } from './svgs/document-info.svg.js';
import { ReactComponent as ForwardRef$6q } from './svgs/document-layout-center.svg.js';
import { ReactComponent as ForwardRef$6r } from './svgs/document-layout-left.svg.js';
import { ReactComponent as ForwardRef$6s } from './svgs/document-layout-right.svg.js';
import { ReactComponent as ForwardRef$6t } from './svgs/dollar-alt.svg.js';
import { ReactComponent as ForwardRef$6u } from './svgs/dollar-sign-alt.svg.js';
import { ReactComponent as ForwardRef$6v } from './svgs/dollar-sign.svg.js';
import { ReactComponent as ForwardRef$6w } from './svgs/download-alt.svg.js';
import { ReactComponent as ForwardRef$6x } from './svgs/draggabledots.svg.js';
import { ReactComponent as ForwardRef$6y } from './svgs/dribbble.svg.js';
import { ReactComponent as ForwardRef$6z } from './svgs/drill.svg.js';
import { ReactComponent as ForwardRef$6A } from './svgs/dropbox.svg.js';
import { ReactComponent as ForwardRef$6B } from './svgs/dumbbell.svg.js';
import { ReactComponent as ForwardRef$6C } from './svgs/ear.svg.js';
import { ReactComponent as ForwardRef$6D } from './svgs/edit-alt.svg.js';
import { ReactComponent as ForwardRef$6E } from './svgs/edit.svg.js';
import { ReactComponent as ForwardRef$6F } from './svgs/ellipsis-h.svg.js';
import { ReactComponent as ForwardRef$6G } from './svgs/ellipsis-v.svg.js';
import { ReactComponent as ForwardRef$6H } from './svgs/emoji.svg.js';
import { ReactComponent as ForwardRef$6I } from './svgs/enter.svg.js';
import { ReactComponent as ForwardRef$6J } from './svgs/envelope-add.svg.js';
import { ReactComponent as ForwardRef$6K } from './svgs/envelope-alt.svg.js';
import { ReactComponent as ForwardRef$6L } from './svgs/envelope-block.svg.js';
import { ReactComponent as ForwardRef$6M } from './svgs/envelope-bookmark.svg.js';
import { ReactComponent as ForwardRef$6N } from './svgs/envelope-check.svg.js';
import { ReactComponent as ForwardRef$6O } from './svgs/envelope-download-alt.svg.js';
import { ReactComponent as ForwardRef$6P } from './svgs/envelope-download.svg.js';
import { ReactComponent as ForwardRef$6Q } from './svgs/envelope-edit.svg.js';
import { ReactComponent as ForwardRef$6R } from './svgs/envelope-exclamation.svg.js';
import { ReactComponent as ForwardRef$6S } from './svgs/envelope-heart.svg.js';
import { ReactComponent as ForwardRef$6T } from './svgs/envelope-info.svg.js';
import { ReactComponent as ForwardRef$6U } from './svgs/envelope-lock.svg.js';
import { ReactComponent as ForwardRef$6V } from './svgs/envelope-minus.svg.js';
import { ReactComponent as ForwardRef$6W } from './svgs/envelope-open.svg.js';
import { ReactComponent as ForwardRef$6X } from './svgs/envelope-question.svg.js';
import { ReactComponent as ForwardRef$6Y } from './svgs/envelope-receive.svg.js';
import { ReactComponent as ForwardRef$6Z } from './svgs/envelope-redo.svg.js';
import { ReactComponent as ForwardRef$6_ } from './svgs/envelope-search.svg.js';
import { ReactComponent as ForwardRef$6$ } from './svgs/envelope-send.svg.js';
import { ReactComponent as ForwardRef$70 } from './svgs/envelope-share.svg.js';
import { ReactComponent as ForwardRef$71 } from './svgs/envelope-shield.svg.js';
import { ReactComponent as ForwardRef$72 } from './svgs/envelope-star.svg.js';
import { ReactComponent as ForwardRef$73 } from './svgs/envelope-times.svg.js';
import { ReactComponent as ForwardRef$74 } from './svgs/envelope-upload-alt.svg.js';
import { ReactComponent as ForwardRef$75 } from './svgs/envelope-upload.svg.js';
import { ReactComponent as ForwardRef$76 } from './svgs/envelope.svg.js';
import { ReactComponent as ForwardRef$77 } from './svgs/envelopes.svg.js';
import { ReactComponent as ForwardRef$78 } from './svgs/equal-circle.svg.js';
import { ReactComponent as ForwardRef$79 } from './svgs/euro-circle.svg.js';
import { ReactComponent as ForwardRef$7a } from './svgs/euro.svg.js';
import { ReactComponent as ForwardRef$7b } from './svgs/exchange-alt.svg.js';
import { ReactComponent as ForwardRef$7c } from './svgs/exchange.svg.js';
import { ReactComponent as ForwardRef$7d } from './svgs/exclamation-circle.svg.js';
import { ReactComponent as ForwardRef$7e } from './svgs/exclamation-octagon.svg.js';
import { ReactComponent as ForwardRef$7f } from './svgs/exclamation-triangle.svg.js';
import { ReactComponent as ForwardRef$7g } from './svgs/exclude.svg.js';
import { ReactComponent as ForwardRef$7h } from './svgs/exit.svg.js';
import { ReactComponent as ForwardRef$7i } from './svgs/expand-alt.svg.js';
import { ReactComponent as ForwardRef$7j } from './svgs/expand-arrows-alt.svg.js';
import { ReactComponent as ForwardRef$7k } from './svgs/expand-arrows.svg.js';
import { ReactComponent as ForwardRef$7l } from './svgs/expand-from-corner.svg.js';
import { ReactComponent as ForwardRef$7m } from './svgs/expand-left.svg.js';
import { ReactComponent as ForwardRef$7n } from './svgs/expand-right.svg.js';
import { ReactComponent as ForwardRef$7o } from './svgs/export.svg.js';
import { ReactComponent as ForwardRef$7p } from './svgs/exposure-alt.svg.js';
import { ReactComponent as ForwardRef$7q } from './svgs/exposure-increase.svg.js';
import { ReactComponent as ForwardRef$7r } from './svgs/external-link-alt.svg.js';
import { ReactComponent as ForwardRef$7s } from './svgs/eye-slash.svg.js';
import { ReactComponent as ForwardRef$7t } from './svgs/eye.svg.js';
import { ReactComponent as ForwardRef$7u } from './svgs/facebook-f.svg.js';
import { ReactComponent as ForwardRef$7v } from './svgs/facebook-messenger-alt.svg.js';
import { ReactComponent as ForwardRef$7w } from './svgs/facebook-messenger.svg.js';
import { ReactComponent as ForwardRef$7x } from './svgs/facebook.svg.js';
import { ReactComponent as ForwardRef$7y } from './svgs/fahrenheit.svg.js';
import { ReactComponent as ForwardRef$7z } from './svgs/fast-mail-alt.svg.js';
import { ReactComponent as ForwardRef$7A } from './svgs/fast-mail.svg.js';
import { ReactComponent as ForwardRef$7B } from './svgs/favorite.svg.js';
import { ReactComponent as ForwardRef$7C } from './svgs/feedback.svg.js';
import { ReactComponent as ForwardRef$7D } from './svgs/file-alt.svg.js';
import { ReactComponent as ForwardRef$7E } from './svgs/file-blank.svg.js';
import { ReactComponent as ForwardRef$7F } from './svgs/file-block-alt.svg.js';
import { ReactComponent as ForwardRef$7G } from './svgs/file-bookmark-alt.svg.js';
import { ReactComponent as ForwardRef$7H } from './svgs/file-check-alt.svg.js';
import { ReactComponent as ForwardRef$7I } from './svgs/file-check.svg.js';
import { ReactComponent as ForwardRef$7J } from './svgs/file-contract-dollar.svg.js';
import { ReactComponent as ForwardRef$7K } from './svgs/file-copy-alt.svg.js';
import { ReactComponent as ForwardRef$7L } from './svgs/file-download-alt.svg.js';
import { ReactComponent as ForwardRef$7M } from './svgs/file-download.svg.js';
import { ReactComponent as ForwardRef$7N } from './svgs/file-edit-alt.svg.js';
import { ReactComponent as ForwardRef$7O } from './svgs/file-exclamation-alt.svg.js';
import { ReactComponent as ForwardRef$7P } from './svgs/file-exclamation.svg.js';
import { ReactComponent as ForwardRef$7Q } from './svgs/file-export.svg.js';
import { ReactComponent as ForwardRef$7R } from './svgs/file-graph.svg.js';
import { ReactComponent as ForwardRef$7S } from './svgs/file-heart.svg.js';
import { ReactComponent as ForwardRef$7T } from './svgs/file-import.svg.js';
import { ReactComponent as ForwardRef$7U } from './svgs/file-info-alt.svg.js';
import { ReactComponent as ForwardRef$7V } from './svgs/file-landscape-alt.svg.js';
import { ReactComponent as ForwardRef$7W } from './svgs/file-landscape.svg.js';
import { ReactComponent as ForwardRef$7X } from './svgs/file-lanscape-slash.svg.js';
import { ReactComponent as ForwardRef$7Y } from './svgs/file-lock-alt.svg.js';
import { ReactComponent as ForwardRef$7Z } from './svgs/file-medical-alt.svg.js';
import { ReactComponent as ForwardRef$7_ } from './svgs/file-medical.svg.js';
import { ReactComponent as ForwardRef$7$ } from './svgs/file-minus-alt.svg.js';
import { ReactComponent as ForwardRef$80 } from './svgs/file-minus.svg.js';
import { ReactComponent as ForwardRef$81 } from './svgs/file-network.svg.js';
import { ReactComponent as ForwardRef$82 } from './svgs/file-plus-alt.svg.js';
import { ReactComponent as ForwardRef$83 } from './svgs/file-plus.svg.js';
import { ReactComponent as ForwardRef$84 } from './svgs/file-question-alt.svg.js';
import { ReactComponent as ForwardRef$85 } from './svgs/file-question.svg.js';
import { ReactComponent as ForwardRef$86 } from './svgs/file-redo-alt.svg.js';
import { ReactComponent as ForwardRef$87 } from './svgs/file-search-alt.svg.js';
import { ReactComponent as ForwardRef$88 } from './svgs/file-share-alt.svg.js';
import { ReactComponent as ForwardRef$89 } from './svgs/file-shield-alt.svg.js';
import { ReactComponent as ForwardRef$8a } from './svgs/file-slash.svg.js';
import { ReactComponent as ForwardRef$8b } from './svgs/file-times-alt.svg.js';
import { ReactComponent as ForwardRef$8c } from './svgs/file-times.svg.js';
import { ReactComponent as ForwardRef$8d } from './svgs/file-upload-alt.svg.js';
import { ReactComponent as ForwardRef$8e } from './svgs/file-upload.svg.js';
import { ReactComponent as ForwardRef$8f } from './svgs/file.svg.js';
import { ReactComponent as ForwardRef$8g } from './svgs/files-landscapes-alt.svg.js';
import { ReactComponent as ForwardRef$8h } from './svgs/files-landscapes.svg.js';
import { ReactComponent as ForwardRef$8i } from './svgs/film.svg.js';
import { ReactComponent as ForwardRef$8j } from './svgs/filter-slash.svg.js';
import { ReactComponent as ForwardRef$8k } from './svgs/filter.svg.js';
import { ReactComponent as ForwardRef$8l } from './svgs/fire.svg.js';
import { ReactComponent as ForwardRef$8m } from './svgs/flask-potion.svg.js';
import { ReactComponent as ForwardRef$8n } from './svgs/flask.svg.js';
import { ReactComponent as ForwardRef$8o } from './svgs/flip-h-alt.svg.js';
import { ReactComponent as ForwardRef$8p } from './svgs/flip-h.svg.js';
import { ReactComponent as ForwardRef$8q } from './svgs/flip-v-alt.svg.js';
import { ReactComponent as ForwardRef$8r } from './svgs/flip-v.svg.js';
import { ReactComponent as ForwardRef$8s } from './svgs/flower.svg.js';
import { ReactComponent as ForwardRef$8t } from './svgs/focus-add.svg.js';
import { ReactComponent as ForwardRef$8u } from './svgs/focus-target.svg.js';
import { ReactComponent as ForwardRef$8v } from './svgs/focus.svg.js';
import { ReactComponent as ForwardRef$8w } from './svgs/folder-check.svg.js';
import { ReactComponent as ForwardRef$8x } from './svgs/folder-download.svg.js';
import { ReactComponent as ForwardRef$8y } from './svgs/folder-exclamation.svg.js';
import { ReactComponent as ForwardRef$8z } from './svgs/folder-heart.svg.js';
import { ReactComponent as ForwardRef$8A } from './svgs/folder-info.svg.js';
import { ReactComponent as ForwardRef$8B } from './svgs/folder-lock.svg.js';
import { ReactComponent as ForwardRef$8C } from './svgs/folder-medical.svg.js';
import { ReactComponent as ForwardRef$8D } from './svgs/folder-minus.svg.js';
import { ReactComponent as ForwardRef$8E } from './svgs/folder-network.svg.js';
import { ReactComponent as ForwardRef$8F } from './svgs/folder-open.svg.js';
import { ReactComponent as ForwardRef$8G } from './svgs/folder-plus.svg.js';
import { ReactComponent as ForwardRef$8H } from './svgs/folder-question.svg.js';
import { ReactComponent as ForwardRef$8I } from './svgs/folder-slash.svg.js';
import { ReactComponent as ForwardRef$8J } from './svgs/folder-times.svg.js';
import { ReactComponent as ForwardRef$8K } from './svgs/folder-upload.svg.js';
import { ReactComponent as ForwardRef$8L } from './svgs/folder.svg.js';
import { ReactComponent as ForwardRef$8M } from './svgs/football-american.svg.js';
import { ReactComponent as ForwardRef$8N } from './svgs/football-ball.svg.js';
import { ReactComponent as ForwardRef$8O } from './svgs/football.svg.js';
import { ReactComponent as ForwardRef$8P } from './svgs/forecastcloud-moon-tear.svg.js';
import { ReactComponent as ForwardRef$8Q } from './svgs/forwaded-call.svg.js';
import { ReactComponent as ForwardRef$8R } from './svgs/forward.svg.js';
import { ReactComponent as ForwardRef$8S } from './svgs/frown.svg.js';
import { ReactComponent as ForwardRef$8T } from './svgs/game-structure.svg.js';
import { ReactComponent as ForwardRef$8U } from './svgs/gift.svg.js';
import { ReactComponent as ForwardRef$8V } from './svgs/github-alt.svg.js';
import { ReactComponent as ForwardRef$8W } from './svgs/github.svg.js';
import { ReactComponent as ForwardRef$8X } from './svgs/glass-martini-alt-slash.svg.js';
import { ReactComponent as ForwardRef$8Y } from './svgs/glass-martini-alt.svg.js';
import { ReactComponent as ForwardRef$8Z } from './svgs/glass-martini.svg.js';
import { ReactComponent as ForwardRef$8_ } from './svgs/glass-tea.svg.js';
import { ReactComponent as ForwardRef$8$ } from './svgs/glass.svg.js';
import { ReactComponent as ForwardRef$90 } from './svgs/globe.svg.js';
import { ReactComponent as ForwardRef$91 } from './svgs/gold.svg.js';
import { ReactComponent as ForwardRef$92 } from './svgs/golf-ball.svg.js';
import { ReactComponent as ForwardRef$93 } from './svgs/google-drive-alt.svg.js';
import { ReactComponent as ForwardRef$94 } from './svgs/google-drive.svg.js';
import { ReactComponent as ForwardRef$95 } from './svgs/google-hangouts-alt.svg.js';
import { ReactComponent as ForwardRef$96 } from './svgs/google-hangouts.svg.js';
import { ReactComponent as ForwardRef$97 } from './svgs/google-play.svg.js';
import { ReactComponent as ForwardRef$98 } from './svgs/google.svg.js';
import { ReactComponent as ForwardRef$99 } from './svgs/graduation-cap.svg.js';
import { ReactComponent as ForwardRef$9a } from './svgs/graph-bar.svg.js';
import { ReactComponent as ForwardRef$9b } from './svgs/grid.svg.js';
import { ReactComponent as ForwardRef$9c } from './svgs/grids.svg.js';
import { ReactComponent as ForwardRef$9d } from './svgs/grin-tongue-wink-alt.svg.js';
import { ReactComponent as ForwardRef$9e } from './svgs/grin-tongue-wink.svg.js';
import { ReactComponent as ForwardRef$9f } from './svgs/grin.svg.js';
import { ReactComponent as ForwardRef$9g } from './svgs/grip-horizontal-line.svg.js';
import { ReactComponent as ForwardRef$9h } from './svgs/hard-hat.svg.js';
import { ReactComponent as ForwardRef$9i } from './svgs/hdd.svg.js';
import { ReactComponent as ForwardRef$9j } from './svgs/head-side-cough.svg.js';
import { ReactComponent as ForwardRef$9k } from './svgs/head-side-mask.svg.js';
import { ReactComponent as ForwardRef$9l } from './svgs/head-side.svg.js';
import { ReactComponent as ForwardRef$9m } from './svgs/headphones-alt.svg.js';
import { ReactComponent as ForwardRef$9n } from './svgs/headphones.svg.js';
import { ReactComponent as ForwardRef$9o } from './svgs/heart-alt.svg.js';
import { ReactComponent as ForwardRef$9p } from './svgs/heart-break.svg.js';
import { ReactComponent as ForwardRef$9q } from './svgs/heart-medical.svg.js';
import { ReactComponent as ForwardRef$9r } from './svgs/heart-rate.svg.js';
import { ReactComponent as ForwardRef$9s } from './svgs/heart-sign.svg.js';
import { ReactComponent as ForwardRef$9t } from './svgs/heart.svg.js';
import { ReactComponent as ForwardRef$9u } from './svgs/heartbeat.svg.js';
import { ReactComponent as ForwardRef$9v } from './svgs/history-alt.svg.js';
import { ReactComponent as ForwardRef$9w } from './svgs/history.svg.js';
import { ReactComponent as ForwardRef$9x } from './svgs/home-alt.svg.js';
import { ReactComponent as ForwardRef$9y } from './svgs/home.svg.js';
import { ReactComponent as ForwardRef$9z } from './svgs/horizontal-align-center.svg.js';
import { ReactComponent as ForwardRef$9A } from './svgs/horizontal-align-left.svg.js';
import { ReactComponent as ForwardRef$9B } from './svgs/horizontal-align-right.svg.js';
import { ReactComponent as ForwardRef$9C } from './svgs/horizontal-distribution-center.svg.js';
import { ReactComponent as ForwardRef$9D } from './svgs/horizontal-distribution-left.svg.js';
import { ReactComponent as ForwardRef$9E } from './svgs/horizontal-distribution-right.svg.js';
import { ReactComponent as ForwardRef$9F } from './svgs/hospital-square-sign.svg.js';
import { ReactComponent as ForwardRef$9G } from './svgs/hospital-symbol.svg.js';
import { ReactComponent as ForwardRef$9H } from './svgs/hospital.svg.js';
import { ReactComponent as ForwardRef$9I } from './svgs/hourglass.svg.js';
import { ReactComponent as ForwardRef$9J } from './svgs/house-user.svg.js';
import { ReactComponent as ForwardRef$9K } from './svgs/html3-alt.svg.js';
import { ReactComponent as ForwardRef$9L } from './svgs/html3.svg.js';
import { ReactComponent as ForwardRef$9M } from './svgs/html5-alt.svg.js';
import { ReactComponent as ForwardRef$9N } from './svgs/html5.svg.js';
import { ReactComponent as ForwardRef$9O } from './svgs/hunting.svg.js';
import { ReactComponent as ForwardRef$9P } from './svgs/image-alt-slash.svg.js';
import { ReactComponent as ForwardRef$9Q } from './svgs/image-block.svg.js';
import { ReactComponent as ForwardRef$9R } from './svgs/image-broken.svg.js';
import { ReactComponent as ForwardRef$9S } from './svgs/image-check.svg.js';
import { ReactComponent as ForwardRef$9T } from './svgs/image-download.svg.js';
import { ReactComponent as ForwardRef$9U } from './svgs/image-edit.svg.js';
import { ReactComponent as ForwardRef$9V } from './svgs/image-lock.svg.js';
import { ReactComponent as ForwardRef$9W } from './svgs/image-minus.svg.js';
import { ReactComponent as ForwardRef$9X } from './svgs/image-plus.svg.js';
import { ReactComponent as ForwardRef$9Y } from './svgs/image-question.svg.js';
import { ReactComponent as ForwardRef$9Z } from './svgs/image-redo.svg.js';
import { ReactComponent as ForwardRef$9_ } from './svgs/image-resize-landscape.svg.js';
import { ReactComponent as ForwardRef$9$ } from './svgs/image-resize-square.svg.js';
import { ReactComponent as ForwardRef$a0 } from './svgs/image-search.svg.js';
import { ReactComponent as ForwardRef$a1 } from './svgs/image-share.svg.js';
import { ReactComponent as ForwardRef$a2 } from './svgs/image-shield.svg.js';
import { ReactComponent as ForwardRef$a3 } from './svgs/image-slash.svg.js';
import { ReactComponent as ForwardRef$a4 } from './svgs/image-times.svg.js';
import { ReactComponent as ForwardRef$a5 } from './svgs/image-upload.svg.js';
import { ReactComponent as ForwardRef$a6 } from './svgs/image-v.svg.js';
import { ReactComponent as ForwardRef$a7 } from './svgs/image.svg.js';
import { ReactComponent as ForwardRef$a8 } from './svgs/images.svg.js';
import { ReactComponent as ForwardRef$a9 } from './svgs/import.svg.js';
import { ReactComponent as ForwardRef$aa } from './svgs/incoming-call.svg.js';
import { ReactComponent as ForwardRef$ab } from './svgs/info-circle.svg.js';
import { ReactComponent as ForwardRef$ac } from './svgs/instagram-alt.svg.js';
import { ReactComponent as ForwardRef$ad } from './svgs/instagram.svg.js';
import { ReactComponent as ForwardRef$ae } from './svgs/intercom-alt.svg.js';
import { ReactComponent as ForwardRef$af } from './svgs/intercom.svg.js';
import { ReactComponent as ForwardRef$ag } from './svgs/invoice.svg.js';
import { ReactComponent as ForwardRef$ah } from './svgs/italic.svg.js';
import { ReactComponent as ForwardRef$ai } from './svgs/jackhammer.svg.js';
import { ReactComponent as ForwardRef$aj } from './svgs/java-script.svg.js';
import { ReactComponent as ForwardRef$ak } from './svgs/kayak.svg.js';
import { ReactComponent as ForwardRef$al } from './svgs/key-skeleton-alt.svg.js';
import { ReactComponent as ForwardRef$am } from './svgs/key-skeleton.svg.js';
import { ReactComponent as ForwardRef$an } from './svgs/keyboard-alt.svg.js';
import { ReactComponent as ForwardRef$ao } from './svgs/keyboard-hide.svg.js';
import { ReactComponent as ForwardRef$ap } from './svgs/keyboard-show.svg.js';
import { ReactComponent as ForwardRef$aq } from './svgs/keyboard.svg.js';
import { ReactComponent as ForwardRef$ar } from './svgs/keyhole-circle.svg.js';
import { ReactComponent as ForwardRef$as } from './svgs/keyhole-square-full.svg.js';
import { ReactComponent as ForwardRef$at } from './svgs/keyhole-square.svg.js';
import { ReactComponent as ForwardRef$au } from './svgs/kid.svg.js';
import { ReactComponent as ForwardRef$av } from './svgs/label-alt.svg.js';
import { ReactComponent as ForwardRef$aw } from './svgs/label.svg.js';
import { ReactComponent as ForwardRef$ax } from './svgs/lamp.svg.js';
import { ReactComponent as ForwardRef$ay } from './svgs/laptop-cloud.svg.js';
import { ReactComponent as ForwardRef$az } from './svgs/laptop-connection.svg.js';
import { ReactComponent as ForwardRef$aA } from './svgs/laptop.svg.js';
import { ReactComponent as ForwardRef$aB } from './svgs/laughing.svg.js';
import { ReactComponent as ForwardRef$aC } from './svgs/layer-group-slash.svg.js';
import { ReactComponent as ForwardRef$aD } from './svgs/layer-group.svg.js';
import { ReactComponent as ForwardRef$aE } from './svgs/layers-alt.svg.js';
import { ReactComponent as ForwardRef$aF } from './svgs/layers-slash.svg.js';
import { ReactComponent as ForwardRef$aG } from './svgs/layers.svg.js';
import { ReactComponent as ForwardRef$aH } from './svgs/left-arrow-from-left.svg.js';
import { ReactComponent as ForwardRef$aI } from './svgs/left-arrow-to-left.svg.js';
import { ReactComponent as ForwardRef$aJ } from './svgs/left-indent-alt.svg.js';
import { ReactComponent as ForwardRef$aK } from './svgs/left-indent.svg.js';
import { ReactComponent as ForwardRef$aL } from './svgs/left-to-right-text-direction.svg.js';
import { ReactComponent as ForwardRef$aM } from './svgs/life-ring.svg.js';
import { ReactComponent as ForwardRef$aN } from './svgs/lightbulb-alt.svg.js';
import { ReactComponent as ForwardRef$aO } from './svgs/lightbulb.svg.js';
import { ReactComponent as ForwardRef$aP } from './svgs/line-alt.svg.js';
import { ReactComponent as ForwardRef$aQ } from './svgs/line-spacing.svg.js';
import { ReactComponent as ForwardRef$aR } from './svgs/line.svg.js';
import { ReactComponent as ForwardRef$aS } from './svgs/link-add.svg.js';
import { ReactComponent as ForwardRef$aT } from './svgs/link-alt.svg.js';
import { ReactComponent as ForwardRef$aU } from './svgs/link-broken.svg.js';
import { ReactComponent as ForwardRef$aV } from './svgs/link-h.svg.js';
import { ReactComponent as ForwardRef$aW } from './svgs/link.svg.js';
import { ReactComponent as ForwardRef$aX } from './svgs/linkedin-alt.svg.js';
import { ReactComponent as ForwardRef$aY } from './svgs/linkedin.svg.js';
import { ReactComponent as ForwardRef$aZ } from './svgs/lira-sign.svg.js';
import { ReactComponent as ForwardRef$a_ } from './svgs/list-ui-alt.svg.js';
import { ReactComponent as ForwardRef$a$ } from './svgs/list-ul.svg.js';
import { ReactComponent as ForwardRef$b0 } from './svgs/location-arrow-alt.svg.js';
import { ReactComponent as ForwardRef$b1 } from './svgs/location-arrow.svg.js';
import { ReactComponent as ForwardRef$b2 } from './svgs/location-pin-alt.svg.js';
import { ReactComponent as ForwardRef$b3 } from './svgs/location-point.svg.js';
import { ReactComponent as ForwardRef$b4 } from './svgs/lock-access.svg.js';
import { ReactComponent as ForwardRef$b5 } from './svgs/lock-alt.svg.js';
import { ReactComponent as ForwardRef$b6 } from './svgs/lock-open-alt.svg.js';
import { ReactComponent as ForwardRef$b7 } from './svgs/lock-slash.svg.js';
import { ReactComponent as ForwardRef$b8 } from './svgs/lock.svg.js';
import { ReactComponent as ForwardRef$b9 } from './svgs/luggage-cart.svg.js';
import { ReactComponent as ForwardRef$ba } from './svgs/mailbox-alt.svg.js';
import { ReactComponent as ForwardRef$bb } from './svgs/mailbox.svg.js';
import { ReactComponent as ForwardRef$bc } from './svgs/map-marker-alt.svg.js';
import { ReactComponent as ForwardRef$bd } from './svgs/map-marker-edit.svg.js';
import { ReactComponent as ForwardRef$be } from './svgs/map-marker-info.svg.js';
import { ReactComponent as ForwardRef$bf } from './svgs/map-marker-minus.svg.js';
import { ReactComponent as ForwardRef$bg } from './svgs/map-marker-plus.svg.js';
import { ReactComponent as ForwardRef$bh } from './svgs/map-marker-question.svg.js';
import { ReactComponent as ForwardRef$bi } from './svgs/map-marker-shield.svg.js';
import { ReactComponent as ForwardRef$bj } from './svgs/map-marker-slash.svg.js';
import { ReactComponent as ForwardRef$bk } from './svgs/map-marker.svg.js';
import { ReactComponent as ForwardRef$bl } from './svgs/map-pin-alt.svg.js';
import { ReactComponent as ForwardRef$bm } from './svgs/map-pin.svg.js';
import { ReactComponent as ForwardRef$bn } from './svgs/map.svg.js';
import { ReactComponent as ForwardRef$bo } from './svgs/mars.svg.js';
import { ReactComponent as ForwardRef$bp } from './svgs/master-card.svg.js';
import { ReactComponent as ForwardRef$bq } from './svgs/maximize-left.svg.js';
import { ReactComponent as ForwardRef$br } from './svgs/medal.svg.js';
import { ReactComponent as ForwardRef$bs } from './svgs/medical-drip.svg.js';
import { ReactComponent as ForwardRef$bt } from './svgs/medical-square-full.svg.js';
import { ReactComponent as ForwardRef$bu } from './svgs/medical-square.svg.js';
import { ReactComponent as ForwardRef$bv } from './svgs/medical.svg.js';
import { ReactComponent as ForwardRef$bw } from './svgs/medium-m.svg.js';
import { ReactComponent as ForwardRef$bx } from './svgs/medkit.svg.js';
import { ReactComponent as ForwardRef$by } from './svgs/meeting-board.svg.js';
import { ReactComponent as ForwardRef$bz } from './svgs/megaphone.svg.js';
import { ReactComponent as ForwardRef$bA } from './svgs/meh-alt.svg.js';
import { ReactComponent as ForwardRef$bB } from './svgs/meh-closed-eye.svg.js';
import { ReactComponent as ForwardRef$bC } from './svgs/meh.svg.js';
import { ReactComponent as ForwardRef$bD } from './svgs/message.svg.js';
import { ReactComponent as ForwardRef$bE } from './svgs/metro.svg.js';
import { ReactComponent as ForwardRef$bF } from './svgs/microphone-slash.svg.js';
import { ReactComponent as ForwardRef$bG } from './svgs/microphone.svg.js';
import { ReactComponent as ForwardRef$bH } from './svgs/microscope.svg.js';
import { ReactComponent as ForwardRef$bI } from './svgs/minus-circle.svg.js';
import { ReactComponent as ForwardRef$bJ } from './svgs/minus-path.svg.js';
import { ReactComponent as ForwardRef$bK } from './svgs/minus-square-full.svg.js';
import { ReactComponent as ForwardRef$bL } from './svgs/minus-square.svg.js';
import { ReactComponent as ForwardRef$bM } from './svgs/minus.svg.js';
import { ReactComponent as ForwardRef$bN } from './svgs/missed-call.svg.js';
import { ReactComponent as ForwardRef$bO } from './svgs/mobile-android-alt.svg.js';
import { ReactComponent as ForwardRef$bP } from './svgs/mobile-android.svg.js';
import { ReactComponent as ForwardRef$bQ } from './svgs/mobile-vibrate.svg.js';
import { ReactComponent as ForwardRef$bR } from './svgs/modem.svg.js';
import { ReactComponent as ForwardRef$bS } from './svgs/money-bill-slash.svg.js';
import { ReactComponent as ForwardRef$bT } from './svgs/money-bill-stack.svg.js';
import { ReactComponent as ForwardRef$bU } from './svgs/money-bill.svg.js';
import { ReactComponent as ForwardRef$bV } from './svgs/money-insert.svg.js';
import { ReactComponent as ForwardRef$bW } from './svgs/money-stack.svg.js';
import { ReactComponent as ForwardRef$bX } from './svgs/money-withdraw.svg.js';
import { ReactComponent as ForwardRef$bY } from './svgs/money-withdrawal.svg.js';
import { ReactComponent as ForwardRef$bZ } from './svgs/moneybag-alt.svg.js';
import { ReactComponent as ForwardRef$b_ } from './svgs/moneybag.svg.js';
import { ReactComponent as ForwardRef$b$ } from './svgs/monitor-heart-rate.svg.js';
import { ReactComponent as ForwardRef$c0 } from './svgs/monitor.svg.js';
import { ReactComponent as ForwardRef$c1 } from './svgs/moon-eclipse.svg.js';
import { ReactComponent as ForwardRef$c2 } from './svgs/moon.svg.js';
import { ReactComponent as ForwardRef$c3 } from './svgs/moonset.svg.js';
import { ReactComponent as ForwardRef$c4 } from './svgs/mountains-sun.svg.js';
import { ReactComponent as ForwardRef$c5 } from './svgs/mountains.svg.js';
import { ReactComponent as ForwardRef$c6 } from './svgs/mouse-alt-2.svg.js';
import { ReactComponent as ForwardRef$c7 } from './svgs/mouse-alt.svg.js';
import { ReactComponent as ForwardRef$c8 } from './svgs/mouse.svg.js';
import { ReactComponent as ForwardRef$c9 } from './svgs/multiply.svg.js';
import { ReactComponent as ForwardRef$ca } from './svgs/music-note.svg.js';
import { ReactComponent as ForwardRef$cb } from './svgs/music-tune-slash.svg.js';
import { ReactComponent as ForwardRef$cc } from './svgs/music.svg.js';
import { ReactComponent as ForwardRef$cd } from './svgs/n-a.svg.js';
import { ReactComponent as ForwardRef$ce } from './svgs/navigator.svg.js';
import { ReactComponent as ForwardRef$cf } from './svgs/nerd.svg.js';
import { ReactComponent as ForwardRef$cg } from './svgs/newspaper.svg.js';
import { ReactComponent as ForwardRef$ch } from './svgs/ninja.svg.js';
import { ReactComponent as ForwardRef$ci } from './svgs/no-entry.svg.js';
import { ReactComponent as ForwardRef$cj } from './svgs/notebooks.svg.js';
import { ReactComponent as ForwardRef$ck } from './svgs/notes.svg.js';
import { ReactComponent as ForwardRef$cl } from './svgs/object-group.svg.js';
import { ReactComponent as ForwardRef$cm } from './svgs/object-ungroup.svg.js';
import { ReactComponent as ForwardRef$cn } from './svgs/octagon.svg.js';
import { ReactComponent as ForwardRef$co } from './svgs/opera-alt.svg.js';
import { ReactComponent as ForwardRef$cp } from './svgs/opera.svg.js';
import { ReactComponent as ForwardRef$cq } from './svgs/outgoing-call.svg.js';
import { ReactComponent as ForwardRef$cr } from './svgs/package.svg.js';
import { ReactComponent as ForwardRef$cs } from './svgs/padlock.svg.js';
import { ReactComponent as ForwardRef$ct } from './svgs/paint-tool.svg.js';
import { ReactComponent as ForwardRef$cu } from './svgs/palette.svg.js';
import { ReactComponent as ForwardRef$cv } from './svgs/panel-add.svg.js';
import { ReactComponent as ForwardRef$cw } from './svgs/panorama-h-alt.svg.js';
import { ReactComponent as ForwardRef$cx } from './svgs/panorama-h.svg.js';
import { ReactComponent as ForwardRef$cy } from './svgs/panorama-v.svg.js';
import { ReactComponent as ForwardRef$cz } from './svgs/paperclip.svg.js';
import { ReactComponent as ForwardRef$cA } from './svgs/paragraph.svg.js';
import { ReactComponent as ForwardRef$cB } from './svgs/parcel.svg.js';
import { ReactComponent as ForwardRef$cC } from './svgs/parking-circle.svg.js';
import { ReactComponent as ForwardRef$cD } from './svgs/parking-square.svg.js';
import { ReactComponent as ForwardRef$cE } from './svgs/pathfinder-unite.svg.js';
import { ReactComponent as ForwardRef$cF } from './svgs/pathfinder.svg.js';
import { ReactComponent as ForwardRef$cG } from './svgs/pause-circle.svg.js';
import { ReactComponent as ForwardRef$cH } from './svgs/pause.svg.js';
import { ReactComponent as ForwardRef$cI } from './svgs/paypal.svg.js';
import { ReactComponent as ForwardRef$cJ } from './svgs/pen.svg.js';
import { ReactComponent as ForwardRef$cK } from './svgs/pentagon.svg.js';
import { ReactComponent as ForwardRef$cL } from './svgs/percentage.svg.js';
import { ReactComponent as ForwardRef$cM } from './svgs/phone-alt.svg.js';
import { ReactComponent as ForwardRef$cN } from './svgs/phone-pause.svg.js';
import { ReactComponent as ForwardRef$cO } from './svgs/phone-slash.svg.js';
import { ReactComponent as ForwardRef$cP } from './svgs/phone-times.svg.js';
import { ReactComponent as ForwardRef$cQ } from './svgs/phone-volume.svg.js';
import { ReactComponent as ForwardRef$cR } from './svgs/phone.svg.js';
import { ReactComponent as ForwardRef$cS } from './svgs/picture.svg.js';
import { ReactComponent as ForwardRef$cT } from './svgs/pizza-slice.svg.js';
import { ReactComponent as ForwardRef$cU } from './svgs/plane-arrival.svg.js';
import { ReactComponent as ForwardRef$cV } from './svgs/plane-departure.svg.js';
import { ReactComponent as ForwardRef$cW } from './svgs/plane-fly.svg.js';
import { ReactComponent as ForwardRef$cX } from './svgs/plane.svg.js';
import { ReactComponent as ForwardRef$cY } from './svgs/play-circle.svg.js';
import { ReactComponent as ForwardRef$cZ } from './svgs/play.svg.js';
import { ReactComponent as ForwardRef$c_ } from './svgs/plug.svg.js';
import { ReactComponent as ForwardRef$c$ } from './svgs/plus-circle.svg.js';
import { ReactComponent as ForwardRef$d0 } from './svgs/plus-square.svg.js';
import { ReactComponent as ForwardRef$d1 } from './svgs/plus.svg.js';
import { ReactComponent as ForwardRef$d2 } from './svgs/podium.svg.js';
import { ReactComponent as ForwardRef$d3 } from './svgs/polygon.svg.js';
import { ReactComponent as ForwardRef$d4 } from './svgs/post-stamp.svg.js';
import { ReactComponent as ForwardRef$d5 } from './svgs/postcard.svg.js';
import { ReactComponent as ForwardRef$d6 } from './svgs/pound-circle.svg.js';
import { ReactComponent as ForwardRef$d7 } from './svgs/pound.svg.js';
import { ReactComponent as ForwardRef$d8 } from './svgs/power.svg.js';
import { ReactComponent as ForwardRef$d9 } from './svgs/prescription-bottle.svg.js';
import { ReactComponent as ForwardRef$da } from './svgs/presentation-check.svg.js';
import { ReactComponent as ForwardRef$db } from './svgs/presentation-edit.svg.js';
import { ReactComponent as ForwardRef$dc } from './svgs/presentation-line.svg.js';
import { ReactComponent as ForwardRef$dd } from './svgs/presentation-lines-alt.svg.js';
import { ReactComponent as ForwardRef$de } from './svgs/presentation-minus.svg.js';
import { ReactComponent as ForwardRef$df } from './svgs/presentation-play.svg.js';
import { ReactComponent as ForwardRef$dg } from './svgs/presentation-plus.svg.js';
import { ReactComponent as ForwardRef$dh } from './svgs/presentation-times.svg.js';
import { ReactComponent as ForwardRef$di } from './svgs/presentation.svg.js';
import { ReactComponent as ForwardRef$dj } from './svgs/previous.svg.js';
import { ReactComponent as ForwardRef$dk } from './svgs/pricetag-alt.svg.js';
import { ReactComponent as ForwardRef$dl } from './svgs/print-slash.svg.js';
import { ReactComponent as ForwardRef$dm } from './svgs/print.svg.js';
import { ReactComponent as ForwardRef$dn } from './svgs/process.svg.js';
import { ReactComponent as ForwardRef$do } from './svgs/processor.svg.js';
import { ReactComponent as ForwardRef$dp } from './svgs/programming-language.svg.js';
import { ReactComponent as ForwardRef$dq } from './svgs/pump.svg.js';
import { ReactComponent as ForwardRef$dr } from './svgs/puzzle-piece.svg.js';
import { ReactComponent as ForwardRef$ds } from './svgs/qrcode-scan.svg.js';
import { ReactComponent as ForwardRef$dt } from './svgs/question-circle.svg.js';
import { ReactComponent as ForwardRef$du } from './svgs/rainbow.svg.js';
import { ReactComponent as ForwardRef$dv } from './svgs/raindrops-alt.svg.js';
import { ReactComponent as ForwardRef$dw } from './svgs/raindrops.svg.js';
import { ReactComponent as ForwardRef$dx } from './svgs/react.svg.js';
import { ReactComponent as ForwardRef$dy } from './svgs/receipt-alt.svg.js';
import { ReactComponent as ForwardRef$dz } from './svgs/receipt.svg.js';
import { ReactComponent as ForwardRef$dA } from './svgs/record-audio.svg.js';
import { ReactComponent as ForwardRef$dB } from './svgs/reddit-alien-alt.svg.js';
import { ReactComponent as ForwardRef$dC } from './svgs/redo.svg.js';
import { ReactComponent as ForwardRef$dD } from './svgs/refresh.svg.js';
import { ReactComponent as ForwardRef$dE } from './svgs/registered.svg.js';
import { ReactComponent as ForwardRef$dF } from './svgs/repeat.svg.js';
import { ReactComponent as ForwardRef$dG } from './svgs/restaurant.svg.js';
import { ReactComponent as ForwardRef$dH } from './svgs/right-indent-alt.svg.js';
import { ReactComponent as ForwardRef$dI } from './svgs/right-to-left-text-direction.svg.js';
import { ReactComponent as ForwardRef$dJ } from './svgs/robot.svg.js';
import { ReactComponent as ForwardRef$dK } from './svgs/rocket.svg.js';
import { ReactComponent as ForwardRef$dL } from './svgs/rope-way.svg.js';
import { ReactComponent as ForwardRef$dM } from './svgs/rotate-360.svg.js';
import { ReactComponent as ForwardRef$dN } from './svgs/rss-alt.svg.js';
import { ReactComponent as ForwardRef$dO } from './svgs/rss-interface.svg.js';
import { ReactComponent as ForwardRef$dP } from './svgs/rss.svg.js';
import { ReactComponent as ForwardRef$dQ } from './svgs/ruler-combined.svg.js';
import { ReactComponent as ForwardRef$dR } from './svgs/ruler.svg.js';
import { ReactComponent as ForwardRef$dS } from './svgs/rupee-sign.svg.js';
import { ReactComponent as ForwardRef$dT } from './svgs/sad-cry.svg.js';
import { ReactComponent as ForwardRef$dU } from './svgs/sad-crying.svg.js';
import { ReactComponent as ForwardRef$dV } from './svgs/sad-dizzy.svg.js';
import { ReactComponent as ForwardRef$dW } from './svgs/sad-squint.svg.js';
import { ReactComponent as ForwardRef$dX } from './svgs/sad.svg.js';
import { ReactComponent as ForwardRef$dY } from './svgs/sanitizer-alt.svg.js';
import { ReactComponent as ForwardRef$dZ } from './svgs/sanitizer.svg.js';
import { ReactComponent as ForwardRef$d_ } from './svgs/save.svg.js';
import { ReactComponent as ForwardRef$d$ } from './svgs/scaling-left.svg.js';
import { ReactComponent as ForwardRef$e0 } from './svgs/scaling-right.svg.js';
import { ReactComponent as ForwardRef$e1 } from './svgs/scenery.svg.js';
import { ReactComponent as ForwardRef$e2 } from './svgs/schedule.svg.js';
import { ReactComponent as ForwardRef$e3 } from './svgs/screw.svg.js';
import { ReactComponent as ForwardRef$e4 } from './svgs/scroll-h.svg.js';
import { ReactComponent as ForwardRef$e5 } from './svgs/scroll.svg.js';
import { ReactComponent as ForwardRef$e6 } from './svgs/search-alt.svg.js';
import { ReactComponent as ForwardRef$e7 } from './svgs/search-minus.svg.js';
import { ReactComponent as ForwardRef$e8 } from './svgs/search-plus.svg.js';
import { ReactComponent as ForwardRef$e9 } from './svgs/search.svg.js';
import { ReactComponent as ForwardRef$ea } from './svgs/selfie.svg.js';
import { ReactComponent as ForwardRef$eb } from './svgs/server-alt.svg.js';
import { ReactComponent as ForwardRef$ec } from './svgs/server-connection.svg.js';
import { ReactComponent as ForwardRef$ed } from './svgs/server-network-alt.svg.js';
import { ReactComponent as ForwardRef$ee } from './svgs/server-network.svg.js';
import { ReactComponent as ForwardRef$ef } from './svgs/server.svg.js';
import { ReactComponent as ForwardRef$eg } from './svgs/servers.svg.js';
import { ReactComponent as ForwardRef$eh } from './svgs/servicemark.svg.js';
import { ReactComponent as ForwardRef$ei } from './svgs/setting.svg.js';
import { ReactComponent as ForwardRef$ej } from './svgs/share-alt.svg.js';
import { ReactComponent as ForwardRef$ek } from './svgs/share.svg.js';
import { ReactComponent as ForwardRef$el } from './svgs/shield-check.svg.js';
import { ReactComponent as ForwardRef$em } from './svgs/shield-exclamation.svg.js';
import { ReactComponent as ForwardRef$en } from './svgs/shield-plus.svg.js';
import { ReactComponent as ForwardRef$eo } from './svgs/shield-question.svg.js';
import { ReactComponent as ForwardRef$ep } from './svgs/shield-slash.svg.js';
import { ReactComponent as ForwardRef$eq } from './svgs/shield.svg.js';
import { ReactComponent as ForwardRef$er } from './svgs/ship.svg.js';
import { ReactComponent as ForwardRef$es } from './svgs/shop.svg.js';
import { ReactComponent as ForwardRef$et } from './svgs/shopping-bag.svg.js';
import { ReactComponent as ForwardRef$eu } from './svgs/shopping-basket.svg.js';
import { ReactComponent as ForwardRef$ev } from './svgs/shopping-cart-alt.svg.js';
import { ReactComponent as ForwardRef$ew } from './svgs/shopping-cart.svg.js';
import { ReactComponent as ForwardRef$ex } from './svgs/shovel.svg.js';
import { ReactComponent as ForwardRef$ey } from './svgs/shrink.svg.js';
import { ReactComponent as ForwardRef$ez } from './svgs/shuffle.svg.js';
import { ReactComponent as ForwardRef$eA } from './svgs/shutter-alt.svg.js';
import { ReactComponent as ForwardRef$eB } from './svgs/shutter.svg.js';
import { ReactComponent as ForwardRef$eC } from './svgs/sick.svg.js';
import { ReactComponent as ForwardRef$eD } from './svgs/sigma.svg.js';
import { ReactComponent as ForwardRef$eE } from './svgs/sign-alt.svg.js';
import { ReactComponent as ForwardRef$eF } from './svgs/sign-in-alt.svg.js';
import { ReactComponent as ForwardRef$eG } from './svgs/sign-left.svg.js';
import { ReactComponent as ForwardRef$eH } from './svgs/sign-out-alt.svg.js';
import { ReactComponent as ForwardRef$eI } from './svgs/sign-right.svg.js';
import { ReactComponent as ForwardRef$eJ } from './svgs/signal-alt-3.svg.js';
import { ReactComponent as ForwardRef$eK } from './svgs/signal-alt.svg.js';
import { ReactComponent as ForwardRef$eL } from './svgs/signal.svg.js';
import { ReactComponent as ForwardRef$eM } from './svgs/signin.svg.js';
import { ReactComponent as ForwardRef$eN } from './svgs/signout.svg.js';
import { ReactComponent as ForwardRef$eO } from './svgs/silence.svg.js';
import { ReactComponent as ForwardRef$eP } from './svgs/silent-squint.svg.js';
import { ReactComponent as ForwardRef$eQ } from './svgs/sim-card.svg.js';
import { ReactComponent as ForwardRef$eR } from './svgs/sitemap.svg.js';
import { ReactComponent as ForwardRef$eS } from './svgs/skip-forward-alt.svg.js';
import { ReactComponent as ForwardRef$eT } from './svgs/skip-forward-circle.svg.js';
import { ReactComponent as ForwardRef$eU } from './svgs/skip-forward.svg.js';
import { ReactComponent as ForwardRef$eV } from './svgs/skype-alt.svg.js';
import { ReactComponent as ForwardRef$eW } from './svgs/skype.svg.js';
import { ReactComponent as ForwardRef$eX } from './svgs/slack-alt.svg.js';
import { ReactComponent as ForwardRef$eY } from './svgs/slack.svg.js';
import { ReactComponent as ForwardRef$eZ } from './svgs/slider-h-range.svg.js';
import { ReactComponent as ForwardRef$e_ } from './svgs/slider-h.svg.js';
import { ReactComponent as ForwardRef$e$ } from './svgs/sliders-v-alt.svg.js';
import { ReactComponent as ForwardRef$f0 } from './svgs/sliders-v.svg.js';
import { ReactComponent as ForwardRef$f1 } from './svgs/smile-beam.svg.js';
import { ReactComponent as ForwardRef$f2 } from './svgs/smile-dizzy.svg.js';
import { ReactComponent as ForwardRef$f3 } from './svgs/smile-squint-wink-alt.svg.js';
import { ReactComponent as ForwardRef$f4 } from './svgs/smile-squint-wink.svg.js';
import { ReactComponent as ForwardRef$f5 } from './svgs/smile-wink-alt.svg.js';
import { ReactComponent as ForwardRef$f6 } from './svgs/smile-wink.svg.js';
import { ReactComponent as ForwardRef$f7 } from './svgs/smile.svg.js';
import { ReactComponent as ForwardRef$f8 } from './svgs/snapchat-alt.svg.js';
import { ReactComponent as ForwardRef$f9 } from './svgs/snapchat-ghost.svg.js';
import { ReactComponent as ForwardRef$fa } from './svgs/snapchat-square.svg.js';
import { ReactComponent as ForwardRef$fb } from './svgs/snow-flake.svg.js';
import { ReactComponent as ForwardRef$fc } from './svgs/snowflake-alt.svg.js';
import { ReactComponent as ForwardRef$fd } from './svgs/snowflake.svg.js';
import { ReactComponent as ForwardRef$fe } from './svgs/social-distancing.svg.js';
import { ReactComponent as ForwardRef$ff } from './svgs/sort-amount-down.svg.js';
import { ReactComponent as ForwardRef$fg } from './svgs/sort-amount-up.svg.js';
import { ReactComponent as ForwardRef$fh } from './svgs/sort.svg.js';
import { ReactComponent as ForwardRef$fi } from './svgs/sorting.svg.js';
import { ReactComponent as ForwardRef$fj } from './svgs/space-key.svg.js';
import { ReactComponent as ForwardRef$fk } from './svgs/spade.svg.js';
import { ReactComponent as ForwardRef$fl } from './svgs/sperms.svg.js';
import { ReactComponent as ForwardRef$fm } from './svgs/spin.svg.js';
import { ReactComponent as ForwardRef$fn } from './svgs/square-full.svg.js';
import { ReactComponent as ForwardRef$fo } from './svgs/square-shape.svg.js';
import { ReactComponent as ForwardRef$fp } from './svgs/square.svg.js';
import { ReactComponent as ForwardRef$fq } from './svgs/squint.svg.js';
import { ReactComponent as ForwardRef$fr } from './svgs/star-half-alt.svg.js';
import { ReactComponent as ForwardRef$fs } from './svgs/star.svg.js';
import { ReactComponent as ForwardRef$ft } from './svgs/step-backward-alt.svg.js';
import { ReactComponent as ForwardRef$fu } from './svgs/step-backward-circle.svg.js';
import { ReactComponent as ForwardRef$fv } from './svgs/step-backward.svg.js';
import { ReactComponent as ForwardRef$fw } from './svgs/step-forward.svg.js';
import { ReactComponent as ForwardRef$fx } from './svgs/stethoscope-alt.svg.js';
import { ReactComponent as ForwardRef$fy } from './svgs/stethoscope.svg.js';
import { ReactComponent as ForwardRef$fz } from './svgs/stop-circle.svg.js';
import { ReactComponent as ForwardRef$fA } from './svgs/stopwatch-slash.svg.js';
import { ReactComponent as ForwardRef$fB } from './svgs/stopwatch.svg.js';
import { ReactComponent as ForwardRef$fC } from './svgs/store-alt.svg.js';
import { ReactComponent as ForwardRef$fD } from './svgs/store-slash.svg.js';
import { ReactComponent as ForwardRef$fE } from './svgs/store.svg.js';
import { ReactComponent as ForwardRef$fF } from './svgs/streering.svg.js';
import { ReactComponent as ForwardRef$fG } from './svgs/stretcher.svg.js';
import { ReactComponent as ForwardRef$fH } from './svgs/subject.svg.js';
import { ReactComponent as ForwardRef$fI } from './svgs/subway-alt.svg.js';
import { ReactComponent as ForwardRef$fJ } from './svgs/subway.svg.js';
import { ReactComponent as ForwardRef$fK } from './svgs/suitcase-alt.svg.js';
import { ReactComponent as ForwardRef$fL } from './svgs/suitcase.svg.js';
import { ReactComponent as ForwardRef$fM } from './svgs/sun.svg.js';
import { ReactComponent as ForwardRef$fN } from './svgs/sunset.svg.js';
import { ReactComponent as ForwardRef$fO } from './svgs/surprise.svg.js';
import { ReactComponent as ForwardRef$fP } from './svgs/swatchbook.svg.js';
import { ReactComponent as ForwardRef$fQ } from './svgs/swiggy.svg.js';
import { ReactComponent as ForwardRef$fR } from './svgs/swimmer.svg.js';
import { ReactComponent as ForwardRef$fS } from './svgs/sync-exclamation.svg.js';
import { ReactComponent as ForwardRef$fT } from './svgs/sync-slash.svg.js';
import { ReactComponent as ForwardRef$fU } from './svgs/sync.svg.js';
import { ReactComponent as ForwardRef$fV } from './svgs/syringe.svg.js';
import { ReactComponent as ForwardRef$fW } from './svgs/table-tennis.svg.js';
import { ReactComponent as ForwardRef$fX } from './svgs/table.svg.js';
import { ReactComponent as ForwardRef$fY } from './svgs/tablet.svg.js';
import { ReactComponent as ForwardRef$fZ } from './svgs/tablets.svg.js';
import { ReactComponent as ForwardRef$f_ } from './svgs/tachometer-fast-alt.svg.js';
import { ReactComponent as ForwardRef$f$ } from './svgs/tachometer-fast.svg.js';
import { ReactComponent as ForwardRef$g0 } from './svgs/tag-alt.svg.js';
import { ReactComponent as ForwardRef$g1 } from './svgs/tag.svg.js';
import { ReactComponent as ForwardRef$g2 } from './svgs/tape.svg.js';
import { ReactComponent as ForwardRef$g3 } from './svgs/taxi.svg.js';
import { ReactComponent as ForwardRef$g4 } from './svgs/tear.svg.js';
import { ReactComponent as ForwardRef$g5 } from './svgs/telegram-alt.svg.js';
import { ReactComponent as ForwardRef$g6 } from './svgs/telegram.svg.js';
import { ReactComponent as ForwardRef$g7 } from './svgs/telescope.svg.js';
import { ReactComponent as ForwardRef$g8 } from './svgs/temperature-empty.svg.js';
import { ReactComponent as ForwardRef$g9 } from './svgs/temperature-half.svg.js';
import { ReactComponent as ForwardRef$ga } from './svgs/temperature-minus.svg.js';
import { ReactComponent as ForwardRef$gb } from './svgs/temperature-plus.svg.js';
import { ReactComponent as ForwardRef$gc } from './svgs/temperature-quarter.svg.js';
import { ReactComponent as ForwardRef$gd } from './svgs/temperature-three-quarter.svg.js';
import { ReactComponent as ForwardRef$ge } from './svgs/temperature.svg.js';
import { ReactComponent as ForwardRef$gf } from './svgs/tennis-ball.svg.js';
import { ReactComponent as ForwardRef$gg } from './svgs/text-fields.svg.js';
import { ReactComponent as ForwardRef$gh } from './svgs/text-size.svg.js';
import { ReactComponent as ForwardRef$gi } from './svgs/text-strike-through.svg.js';
import { ReactComponent as ForwardRef$gj } from './svgs/text.svg.js';
import { ReactComponent as ForwardRef$gk } from './svgs/th-large.svg.js';
import { ReactComponent as ForwardRef$gl } from './svgs/th-slash.svg.js';
import { ReactComponent as ForwardRef$gm } from './svgs/th.svg.js';
import { ReactComponent as ForwardRef$gn } from './svgs/thermometer.svg.js';
import { ReactComponent as ForwardRef$go } from './svgs/thumbs-down.svg.js';
import { ReactComponent as ForwardRef$gp } from './svgs/thumbs-up.svg.js';
import { ReactComponent as ForwardRef$gq } from './svgs/thunderstorm-moon.svg.js';
import { ReactComponent as ForwardRef$gr } from './svgs/thunderstorm-sun.svg.js';
import { ReactComponent as ForwardRef$gs } from './svgs/thunderstorm.svg.js';
import { ReactComponent as ForwardRef$gt } from './svgs/ticket.svg.js';
import { ReactComponent as ForwardRef$gu } from './svgs/times-circle.svg.js';
import { ReactComponent as ForwardRef$gv } from './svgs/times-square.svg.js';
import { ReactComponent as ForwardRef$gw } from './svgs/times.svg.js';
import { ReactComponent as ForwardRef$gx } from './svgs/toggle-off.svg.js';
import { ReactComponent as ForwardRef$gy } from './svgs/toggle-on.svg.js';
import { ReactComponent as ForwardRef$gz } from './svgs/toilet-paper.svg.js';
import { ReactComponent as ForwardRef$gA } from './svgs/top-arrow-from-top.svg.js';
import { ReactComponent as ForwardRef$gB } from './svgs/top-arrow-to-top.svg.js';
import { ReactComponent as ForwardRef$gC } from './svgs/tornado.svg.js';
import { ReactComponent as ForwardRef$gD } from './svgs/trademark-circle.svg.js';
import { ReactComponent as ForwardRef$gE } from './svgs/trademark.svg.js';
import { ReactComponent as ForwardRef$gF } from './svgs/traffic-barrier.svg.js';
import { ReactComponent as ForwardRef$gG } from './svgs/traffic-light.svg.js';
import { ReactComponent as ForwardRef$gH } from './svgs/transaction.svg.js';
import { ReactComponent as ForwardRef$gI } from './svgs/trash-alt.svg.js';
import { ReactComponent as ForwardRef$gJ } from './svgs/trash.svg.js';
import { ReactComponent as ForwardRef$gK } from './svgs/trees.svg.js';
import { ReactComponent as ForwardRef$gL } from './svgs/triangle.svg.js';
import { ReactComponent as ForwardRef$gM } from './svgs/trophy.svg.js';
import { ReactComponent as ForwardRef$gN } from './svgs/trowel.svg.js';
import { ReactComponent as ForwardRef$gO } from './svgs/truck-loading.svg.js';
import { ReactComponent as ForwardRef$gP } from './svgs/truck.svg.js';
import { ReactComponent as ForwardRef$gQ } from './svgs/tumblr-alt.svg.js';
import { ReactComponent as ForwardRef$gR } from './svgs/tumblr-square.svg.js';
import { ReactComponent as ForwardRef$gS } from './svgs/tumblr.svg.js';
import { ReactComponent as ForwardRef$gT } from './svgs/tv-retro-slash.svg.js';
import { ReactComponent as ForwardRef$gU } from './svgs/tv-retro.svg.js';
import { ReactComponent as ForwardRef$gV } from './svgs/twitter-alt.svg.js';
import { ReactComponent as ForwardRef$gW } from './svgs/twitter.svg.js';
import { ReactComponent as ForwardRef$gX } from './svgs/umbrella.svg.js';
import { ReactComponent as ForwardRef$gY } from './svgs/unamused.svg.js';
import { ReactComponent as ForwardRef$gZ } from './svgs/underline.svg.js';
import { ReactComponent as ForwardRef$g_ } from './svgs/university.svg.js';
import { ReactComponent as ForwardRef$g$ } from './svgs/unlock-alt.svg.js';
import { ReactComponent as ForwardRef$h0 } from './svgs/unlock.svg.js';
import { ReactComponent as ForwardRef$h1 } from './svgs/upload-alt.svg.js';
import { ReactComponent as ForwardRef$h2 } from './svgs/upload.svg.js';
import { ReactComponent as ForwardRef$h3 } from './svgs/usd-circle.svg.js';
import { ReactComponent as ForwardRef$h4 } from './svgs/usd-square.svg.js';
import { ReactComponent as ForwardRef$h5 } from './svgs/user-arrows.svg.js';
import { ReactComponent as ForwardRef$h6 } from './svgs/user-check.svg.js';
import { ReactComponent as ForwardRef$h7 } from './svgs/user-circle.svg.js';
import { ReactComponent as ForwardRef$h8 } from './svgs/user-exclamation.svg.js';
import { ReactComponent as ForwardRef$h9 } from './svgs/user-location.svg.js';
import { ReactComponent as ForwardRef$ha } from './svgs/user-md.svg.js';
import { ReactComponent as ForwardRef$hb } from './svgs/user-minus.svg.js';
import { ReactComponent as ForwardRef$hc } from './svgs/user-nurse.svg.js';
import { ReactComponent as ForwardRef$hd } from './svgs/user-plus.svg.js';
import { ReactComponent as ForwardRef$he } from './svgs/user-square.svg.js';
import { ReactComponent as ForwardRef$hf } from './svgs/user-times.svg.js';
import { ReactComponent as ForwardRef$hg } from './svgs/user.svg.js';
import { ReactComponent as ForwardRef$hh } from './svgs/users-alt.svg.js';
import { ReactComponent as ForwardRef$hi } from './svgs/utensils-alt.svg.js';
import { ReactComponent as ForwardRef$hj } from './svgs/utensils.svg.js';
import { ReactComponent as ForwardRef$hk } from './svgs/vector-square-alt.svg.js';
import { ReactComponent as ForwardRef$hl } from './svgs/vector-square.svg.js';
import { ReactComponent as ForwardRef$hm } from './svgs/venus.svg.js';
import { ReactComponent as ForwardRef$hn } from './svgs/vertical-align-bottom.svg.js';
import { ReactComponent as ForwardRef$ho } from './svgs/vertical-align-center.svg.js';
import { ReactComponent as ForwardRef$hp } from './svgs/vertical-align-top.svg.js';
import { ReactComponent as ForwardRef$hq } from './svgs/vertical-distribute-bottom.svg.js';
import { ReactComponent as ForwardRef$hr } from './svgs/vertical-distribution-center.svg.js';
import { ReactComponent as ForwardRef$hs } from './svgs/vertical-distribution-top.svg.js';
import { ReactComponent as ForwardRef$ht } from './svgs/video-slash.svg.js';
import { ReactComponent as ForwardRef$hu } from './svgs/video.svg.js';
import { ReactComponent as ForwardRef$hv } from './svgs/virus-slash.svg.js';
import { ReactComponent as ForwardRef$hw } from './svgs/visual-studio.svg.js';
import { ReactComponent as ForwardRef$hx } from './svgs/vk-alt.svg.js';
import { ReactComponent as ForwardRef$hy } from './svgs/vk.svg.js';
import { ReactComponent as ForwardRef$hz } from './svgs/voicemail-rectangle.svg.js';
import { ReactComponent as ForwardRef$hA } from './svgs/voicemail.svg.js';
import { ReactComponent as ForwardRef$hB } from './svgs/volume-down.svg.js';
import { ReactComponent as ForwardRef$hC } from './svgs/volume-mute.svg.js';
import { ReactComponent as ForwardRef$hD } from './svgs/volume-off.svg.js';
import { ReactComponent as ForwardRef$hE } from './svgs/volume-up.svg.js';
import { ReactComponent as ForwardRef$hF } from './svgs/volume.svg.js';
import { ReactComponent as ForwardRef$hG } from './svgs/vuejs-alt.svg.js';
import { ReactComponent as ForwardRef$hH } from './svgs/vuejs.svg.js';
import { ReactComponent as ForwardRef$hI } from './svgs/wall.svg.js';
import { ReactComponent as ForwardRef$hJ } from './svgs/wallet.svg.js';
import { ReactComponent as ForwardRef$hK } from './svgs/watch-alt.svg.js';
import { ReactComponent as ForwardRef$hL } from './svgs/watch.svg.js';
import { ReactComponent as ForwardRef$hM } from './svgs/water-drop-slash.svg.js';
import { ReactComponent as ForwardRef$hN } from './svgs/water-glass.svg.js';
import { ReactComponent as ForwardRef$hO } from './svgs/water.svg.js';
import { ReactComponent as ForwardRef$hP } from './svgs/web-grid-alt.svg.js';
import { ReactComponent as ForwardRef$hQ } from './svgs/web-grid.svg.js';
import { ReactComponent as ForwardRef$hR } from './svgs/web-section-alt.svg.js';
import { ReactComponent as ForwardRef$hS } from './svgs/web-section.svg.js';
import { ReactComponent as ForwardRef$hT } from './svgs/webcam.svg.js';
import { ReactComponent as ForwardRef$hU } from './svgs/weight.svg.js';
import { ReactComponent as ForwardRef$hV } from './svgs/whatsapp-alt.svg.js';
import { ReactComponent as ForwardRef$hW } from './svgs/whatsapp.svg.js';
import { ReactComponent as ForwardRef$hX } from './svgs/wheel-barrow.svg.js';
import { ReactComponent as ForwardRef$hY } from './svgs/wheelchair-alt.svg.js';
import { ReactComponent as ForwardRef$hZ } from './svgs/wheelchair.svg.js';
import { ReactComponent as ForwardRef$h_ } from './svgs/wifi-router.svg.js';
import { ReactComponent as ForwardRef$h$ } from './svgs/wifi-slash.svg.js';
import { ReactComponent as ForwardRef$i0 } from './svgs/wifi.svg.js';
import { ReactComponent as ForwardRef$i1 } from './svgs/wind-moon.svg.js';
import { ReactComponent as ForwardRef$i2 } from './svgs/wind-sun.svg.js';
import { ReactComponent as ForwardRef$i3 } from './svgs/wind.svg.js';
import { ReactComponent as ForwardRef$i4 } from './svgs/window-grid.svg.js';
import { ReactComponent as ForwardRef$i5 } from './svgs/window-maximize.svg.js';
import { ReactComponent as ForwardRef$i6 } from './svgs/window-section.svg.js';
import { ReactComponent as ForwardRef$i7 } from './svgs/window.svg.js';
import { ReactComponent as ForwardRef$i8 } from './svgs/windsock.svg.js';
import { ReactComponent as ForwardRef$i9 } from './svgs/windy.svg.js';
import { ReactComponent as ForwardRef$ia } from './svgs/wordpress-simple.svg.js';
import { ReactComponent as ForwardRef$ib } from './svgs/wordpress.svg.js';
import { ReactComponent as ForwardRef$ic } from './svgs/wrap-text.svg.js';
import { ReactComponent as ForwardRef$id } from './svgs/wrench.svg.js';
import { ReactComponent as ForwardRef$ie } from './svgs/x-add.svg.js';
import { ReactComponent as ForwardRef$if } from './svgs/x.svg.js';
import { ReactComponent as ForwardRef$ig } from './svgs/yen-circle.svg.js';
import { ReactComponent as ForwardRef$ih } from './svgs/yen.svg.js';
import { ReactComponent as ForwardRef$ii } from './svgs/yin-yang.svg.js';
import { ReactComponent as ForwardRef$ij } from './svgs/youtube.svg.js';

const Plus0Icon = ForwardRef;
const Plus10Icon = ForwardRef$1;
const Plus12Icon = ForwardRef$2;
const Plus13Icon = ForwardRef$3;
const Plus16Icon = ForwardRef$4;
const Plus17Icon = ForwardRef$5;
const Plus18Icon = ForwardRef$6;
const Plus21Icon = ForwardRef$7;
const Plus3Icon = ForwardRef$8;
const Px500Icon = ForwardRef$9;
const Plus6Icon = ForwardRef$a;
const AbacusIcon = ForwardRef$b;
const AccessibleIconAltIcon = ForwardRef$c;
const AdjustAltIcon = ForwardRef$d;
const AdjustCircleIcon = ForwardRef$e;
const AdjustHalfIcon = ForwardRef$f;
const AdjustIcon = ForwardRef$g;
const AdobeAltIcon = ForwardRef$h;
const AdobeIcon = ForwardRef$i;
const AirplayIcon = ForwardRef$j;
const AlignAltIcon = ForwardRef$k;
const AlignCenterAltIcon = ForwardRef$l;
const AlignCenterHIcon = ForwardRef$m;
const AlignCenterJustifyIcon = ForwardRef$n;
const AlignCenterVIcon = ForwardRef$o;
const AlignCenterIcon = ForwardRef$p;
const AlignJustifyIcon = ForwardRef$q;
const AlignLeftJustifyIcon = ForwardRef$r;
const AlignLeftIcon = ForwardRef$s;
const AlignLetterRightIcon = ForwardRef$t;
const AlignRightJustifyIcon = ForwardRef$u;
const AlignRightIcon = ForwardRef$v;
const AlignIcon = ForwardRef$w;
const AmazonIcon = ForwardRef$x;
const AmbulanceIcon = ForwardRef$y;
const AnalysisIcon = ForwardRef$z;
const AnalyticsIcon = ForwardRef$A;
const AnchorIcon = ForwardRef$B;
const AndroidAltIcon = ForwardRef$C;
const AndroidPhoneSlashIcon = ForwardRef$D;
const AndroidIcon = ForwardRef$E;
const AngleDoubleDownIcon = ForwardRef$F;
const AngleDoubleLeftIcon = ForwardRef$G;
const AngleDoubleRightIcon = ForwardRef$H;
const AngleDoubleUpIcon = ForwardRef$I;
const AngleDownIcon = ForwardRef$J;
const AngleLeftBIcon = ForwardRef$K;
const AngleLeftIcon = ForwardRef$L;
const AngleRightBIcon = ForwardRef$M;
const AngleRightIcon = ForwardRef$N;
const AngleUpIcon = ForwardRef$O;
const AngryIcon = ForwardRef$P;
const AnkhIcon = ForwardRef$Q;
const AnnoyedAltIcon = ForwardRef$R;
const AnnoyedIcon = ForwardRef$S;
const AppleAltIcon = ForwardRef$T;
const AppleIcon = ForwardRef$U;
const AppsIcon = ForwardRef$V;
const ArchiveAltIcon = ForwardRef$W;
const ArchiveIcon = ForwardRef$X;
const ArchwayIcon = ForwardRef$Y;
const ArrowBreakIcon = ForwardRef$Z;
const ArrowCircleDownIcon = ForwardRef$_;
const ArrowCircleLeftIcon = ForwardRef$$;
const ArrowCircleRightIcon = ForwardRef$10;
const ArrowCircleUpIcon = ForwardRef$11;
const ArrowCompressHIcon = ForwardRef$12;
const ArrowDownLeftIcon = ForwardRef$13;
const ArrowDownRightIcon = ForwardRef$14;
const ArrowDownIcon = ForwardRef$15;
const ArrowFromRightIcon = ForwardRef$16;
const ArrowFromTopIcon = ForwardRef$17;
const ArrowGrowthIcon = ForwardRef$18;
const ArrowLeftIcon = ForwardRef$19;
const ArrowRandomIcon = ForwardRef$1a;
const ArrowResizeDiagonalIcon = ForwardRef$1b;
const ArrowRightIcon = ForwardRef$1c;
const ArrowToBottomIcon = ForwardRef$1d;
const ArrowToRightIcon = ForwardRef$1e;
const ArrowUpLeftIcon = ForwardRef$1f;
const ArrowUpRightIcon = ForwardRef$1g;
const ArrowUpIcon = ForwardRef$1h;
const ArrowIcon = ForwardRef$1i;
const ArrowsHAltIcon = ForwardRef$1j;
const ArrowsHIcon = ForwardRef$1k;
const ArrowsLeftDownIcon = ForwardRef$1l;
const ArrowsMaximizeIcon = ForwardRef$1m;
const ArrowsMergeIcon = ForwardRef$1n;
const ArrowsResizeHIcon = ForwardRef$1o;
const ArrowsResizeVIcon = ForwardRef$1p;
const ArrowsResizeIcon = ForwardRef$1q;
const ArrowsRightDownIcon = ForwardRef$1r;
const ArrowsShrinkHIcon = ForwardRef$1s;
const ArrowsShrinkVIcon = ForwardRef$1t;
const ArrowsUpRightIcon = ForwardRef$1u;
const ArrowsVAltIcon = ForwardRef$1v;
const ArrowsVIcon = ForwardRef$1w;
const AssistiveListeningSystemsIcon = ForwardRef$1x;
const AsteriskIcon = ForwardRef$1y;
const AtIcon = ForwardRef$1z;
const AtomIcon = ForwardRef$1A;
const AutoFlashIcon = ForwardRef$1B;
const AwardAltIcon = ForwardRef$1C;
const AwardIcon = ForwardRef$1D;
const BabyCarriageIcon = ForwardRef$1E;
const BackpackIcon = ForwardRef$1F;
const BackspaceIcon = ForwardRef$1G;
const BackwardIcon = ForwardRef$1H;
const BagAltIcon = ForwardRef$1I;
const BagSlashIcon = ForwardRef$1J;
const BagIcon = ForwardRef$1K;
const BalanceScaleIcon = ForwardRef$1L;
const BanIcon = ForwardRef$1M;
const BandAidIcon = ForwardRef$1N;
const BarsIcon = ForwardRef$1O;
const BaseballBallIcon = ForwardRef$1P;
const BasketballHoopIcon = ForwardRef$1Q;
const BasketballIcon = ForwardRef$1R;
const BathIcon = ForwardRef$1S;
const BatteryBoltIcon = ForwardRef$1T;
const BatteryEmptyIcon = ForwardRef$1U;
const BedDoubleIcon = ForwardRef$1V;
const BedIcon = ForwardRef$1W;
const BehanceAltIcon = ForwardRef$1X;
const BehanceIcon = ForwardRef$1Y;
const BellSchoolIcon = ForwardRef$1Z;
const BellSlashIcon = ForwardRef$1_;
const BellIcon = ForwardRef$1$;
const BillIcon = ForwardRef$20;
const BingIcon = ForwardRef$21;
const BitcoinAltIcon = ForwardRef$22;
const BitcoinCircleIcon = ForwardRef$23;
const BitcoinSignIcon = ForwardRef$24;
const BitcoinIcon = ForwardRef$25;
const BlackBerryIcon = ForwardRef$26;
const BloggerAltIcon = ForwardRef$27;
const BloggerIcon = ForwardRef$28;
const BluetoothBIcon = ForwardRef$29;
const BoldIcon = ForwardRef$2a;
const BoltAltIcon = ForwardRef$2b;
const BoltSlashIcon = ForwardRef$2c;
const BoltIcon = ForwardRef$2d;
const BookAltIcon = ForwardRef$2e;
const BookMedicalIcon = ForwardRef$2f;
const BookOpenIcon = ForwardRef$2g;
const BookReaderIcon = ForwardRef$2h;
const BookIcon = ForwardRef$2i;
const BookmarkFullIcon = ForwardRef$2j;
const BookmarkIcon = ForwardRef$2k;
const BooksIcon = ForwardRef$2l;
const BoomboxIcon = ForwardRef$2m;
const BorderAltIcon = ForwardRef$2n;
const BorderBottomIcon = ForwardRef$2o;
const BorderClearIcon = ForwardRef$2p;
const BorderHorizontalIcon = ForwardRef$2q;
const BorderInnerIcon = ForwardRef$2r;
const BorderLeftIcon = ForwardRef$2s;
const BorderOutIcon = ForwardRef$2t;
const BorderRightIcon = ForwardRef$2u;
const BorderTopIcon = ForwardRef$2v;
const BorderVerticalIcon = ForwardRef$2w;
const BowlingBallIcon = ForwardRef$2x;
const BoxIcon = ForwardRef$2y;
const BracketsCurlyIcon = ForwardRef$2z;
const BrainIcon = ForwardRef$2A;
const BriefcaseAltIcon = ForwardRef$2B;
const BriefcaseIcon = ForwardRef$2C;
const BrightIcon = ForwardRef$2D;
const BrightnessEmptyIcon = ForwardRef$2E;
const BrightnessHalfIcon = ForwardRef$2F;
const BrightnessLowIcon = ForwardRef$2G;
const BrightnessMinusIcon = ForwardRef$2H;
const BrightnessPlusIcon = ForwardRef$2I;
const BrightnessIcon = ForwardRef$2J;
const BringBottomIcon = ForwardRef$2K;
const BringFrontIcon = ForwardRef$2L;
const BrowserIcon = ForwardRef$2M;
const BrushAltIcon = ForwardRef$2N;
const BugIcon = ForwardRef$2O;
const BuildingIcon = ForwardRef$2P;
const BulletIcon = ForwardRef$2Q;
const BullseyeIcon = ForwardRef$2R;
const BusAltIcon = ForwardRef$2S;
const BusSchoolIcon = ForwardRef$2T;
const BusIcon = ForwardRef$2U;
const CalculatorAltIcon = ForwardRef$2V;
const CalculatorIcon = ForwardRef$2W;
const CalendarAltIcon = ForwardRef$2X;
const CalendarSlashIcon = ForwardRef$2Y;
const CalenderIcon = ForwardRef$2Z;
const CallingIcon = ForwardRef$2_;
const CameraChangeIcon = ForwardRef$2$;
const CameraPlusIcon = ForwardRef$30;
const CameraSlashIcon = ForwardRef$31;
const CameraIcon = ForwardRef$32;
const CancelIcon = ForwardRef$33;
const CapsuleIcon = ForwardRef$34;
const CaptureIcon = ForwardRef$35;
const CarSideviewIcon = ForwardRef$36;
const CarSlashIcon = ForwardRef$37;
const CarWashIcon = ForwardRef$38;
const CarIcon = ForwardRef$39;
const CardAtmIcon = ForwardRef$3a;
const CaretRightIcon = ForwardRef$3b;
const CellIcon = ForwardRef$3c;
const CelsiusIcon = ForwardRef$3d;
const ChannelAddIcon = ForwardRef$3e;
const ChannelIcon = ForwardRef$3f;
const ChartBarAltIcon = ForwardRef$3g;
const ChartBarIcon = ForwardRef$3h;
const ChartDownIcon = ForwardRef$3i;
const ChartGrowthAltIcon = ForwardRef$3j;
const ChartGrowthIcon = ForwardRef$3k;
const ChartLineIcon = ForwardRef$3l;
const ChartPieAltIcon = ForwardRef$3m;
const ChartPieIcon = ForwardRef$3n;
const ChartIcon = ForwardRef$3o;
const ChatBubbleUserIcon = ForwardRef$3p;
const ChatInfoIcon = ForwardRef$3q;
const ChatIcon = ForwardRef$3r;
const CheckCircleIcon = ForwardRef$3s;
const CheckSquareIcon = ForwardRef$3t;
const CheckIcon = ForwardRef$3u;
const CircleLayerIcon = ForwardRef$3v;
const CircleIcon = ForwardRef$3w;
const CircuitIcon = ForwardRef$3x;
const ClapperBoardIcon = ForwardRef$3y;
const ClinicMedicalIcon = ForwardRef$3z;
const ClipboardAltIcon = ForwardRef$3A;
const ClipboardBlankIcon = ForwardRef$3B;
const ClipboardNotesIcon = ForwardRef$3C;
const ClipboardIcon = ForwardRef$3D;
const ClockEightIcon = ForwardRef$3E;
const ClockFiveIcon = ForwardRef$3F;
const ClockNineIcon = ForwardRef$3G;
const ClockSevenIcon = ForwardRef$3H;
const ClockTenIcon = ForwardRef$3I;
const ClockThreeIcon = ForwardRef$3J;
const ClockTwoIcon = ForwardRef$3K;
const ClockIcon = ForwardRef$3L;
const ClosedCaptioningSlashIcon = ForwardRef$3M;
const ClosedCaptioningIcon = ForwardRef$3N;
const CloudBlockIcon = ForwardRef$3O;
const CloudBookmarkIcon = ForwardRef$3P;
const CloudCheckIcon = ForwardRef$3Q;
const CloudComputingIcon = ForwardRef$3R;
const CloudDataConnectionIcon = ForwardRef$3S;
const CloudDatabaseTreeIcon = ForwardRef$3T;
const CloudDownloadIcon = ForwardRef$3U;
const CloudDrizzleIcon = ForwardRef$3V;
const CloudExclamationIcon = ForwardRef$3W;
const CloudHailIcon = ForwardRef$3X;
const CloudHeartIcon = ForwardRef$3Y;
const CloudInfoIcon = ForwardRef$3Z;
const CloudLockIcon = ForwardRef$3_;
const CloudMeatballIcon = ForwardRef$3$;
const CloudMoonHailIcon = ForwardRef$40;
const CloudMoonMeatballIcon = ForwardRef$41;
const CloudMoonRainIcon = ForwardRef$42;
const CloudMoonShowersIcon = ForwardRef$43;
const CloudMoonIcon = ForwardRef$44;
const CloudQuestionIcon = ForwardRef$45;
const CloudRainSunIcon = ForwardRef$46;
const CloudRainIcon = ForwardRef$47;
const CloudRedoIcon = ForwardRef$48;
const CloudShareIcon = ForwardRef$49;
const CloudShieldIcon = ForwardRef$4a;
const CloudShowersAltIcon = ForwardRef$4b;
const CloudShowersHeavyIcon = ForwardRef$4c;
const CloudShowersIcon = ForwardRef$4d;
const CloudSlashIcon = ForwardRef$4e;
const CloudSunHailIcon = ForwardRef$4f;
const CloudSunMeatballIcon = ForwardRef$4g;
const CloudSunRainAltIcon = ForwardRef$4h;
const CloudSunRainIcon = ForwardRef$4i;
const CloudSunTearIcon = ForwardRef$4j;
const CloudSunIcon = ForwardRef$4k;
const CloudTimesIcon = ForwardRef$4l;
const CloudUnlockIcon = ForwardRef$4m;
const CloudUploadIcon = ForwardRef$4n;
const CloudWifiIcon = ForwardRef$4o;
const CloudWindIcon = ForwardRef$4p;
const CloudIcon = ForwardRef$4q;
const CloudsIcon = ForwardRef$4r;
const ClubIcon = ForwardRef$4s;
const CodeBranchIcon = ForwardRef$4t;
const CoffeeIcon = ForwardRef$4u;
const CogIcon = ForwardRef$4v;
const CoinsIcon = ForwardRef$4w;
const ColumnsIcon = ForwardRef$4x;
const CommentAddIcon = ForwardRef$4y;
const CommentAltBlockIcon = ForwardRef$4z;
const CommentAltChartLinesIcon = ForwardRef$4A;
const CommentAltCheckIcon = ForwardRef$4B;
const CommentAltDotsIcon = ForwardRef$4C;
const CommentAltDownloadIcon = ForwardRef$4D;
const CommentAltEditIcon = ForwardRef$4E;
const CommentAltExclamationIcon = ForwardRef$4F;
const CommentAltHeartIcon = ForwardRef$4G;
const CommentAltImageIcon = ForwardRef$4H;
const CommentAltInfoIcon = ForwardRef$4I;
const CommentAltLinesIcon = ForwardRef$4J;
const CommentAltLockIcon = ForwardRef$4K;
const CommentAltMedicalIcon = ForwardRef$4L;
const CommentAltMessageIcon = ForwardRef$4M;
const CommentAltNotesIcon = ForwardRef$4N;
const CommentAltPlusIcon = ForwardRef$4O;
const CommentAltQuestionIcon = ForwardRef$4P;
const CommentAltRedoIcon = ForwardRef$4Q;
const CommentAltSearchIcon = ForwardRef$4R;
const CommentAltShareIcon = ForwardRef$4S;
const CommentAltShieldIcon = ForwardRef$4T;
const CommentAltSlashIcon = ForwardRef$4U;
const CommentAltUploadIcon = ForwardRef$4V;
const CommentAltVerifyIcon = ForwardRef$4W;
const CommentAltIcon = ForwardRef$4X;
const CommentBlockIcon = ForwardRef$4Y;
const CommentChartLineIcon = ForwardRef$4Z;
const CommentCheckIcon = ForwardRef$4_;
const CommentDotsIcon = ForwardRef$4$;
const CommentDownloadIcon = ForwardRef$50;
const CommentEditIcon = ForwardRef$51;
const CommentExclamationIcon = ForwardRef$52;
const CommentHeartIcon = ForwardRef$53;
const CommentImageIcon = ForwardRef$54;
const CommentInfoAltIcon = ForwardRef$55;
const CommentInfoIcon = ForwardRef$56;
const CommentLinesIcon = ForwardRef$57;
const CommentLockIcon = ForwardRef$58;
const CommentMedicalIcon = ForwardRef$59;
const CommentMessageIcon = ForwardRef$5a;
const CommentNotesIcon = ForwardRef$5b;
const CommentPlusIcon = ForwardRef$5c;
const CommentQuestionIcon = ForwardRef$5d;
const CommentRedoIcon = ForwardRef$5e;
const CommentSearchIcon = ForwardRef$5f;
const CommentShareIcon = ForwardRef$5g;
const CommentShieldIcon = ForwardRef$5h;
const CommentSlashIcon = ForwardRef$5i;
const CommentUploadIcon = ForwardRef$5j;
const CommentVerifyIcon = ForwardRef$5k;
const CommentIcon = ForwardRef$5l;
const CommentsAltIcon = ForwardRef$5m;
const CommentsIcon = ForwardRef$5n;
const CompactDiscIcon = ForwardRef$5o;
const ComparisonIcon = ForwardRef$5p;
const CompassIcon = ForwardRef$5q;
const CompressAltLeftIcon = ForwardRef$5r;
const CompressAltIcon = ForwardRef$5s;
const CompressArrowsIcon = ForwardRef$5t;
const CompressLinesIcon = ForwardRef$5u;
const CompressPointIcon = ForwardRef$5v;
const CompressVIcon = ForwardRef$5w;
const CompressIcon = ForwardRef$5x;
const ConfusedIcon = ForwardRef$5y;
const ConstructorIcon = ForwardRef$5z;
const CopyAltIcon = ForwardRef$5A;
const CopyLandscapeIcon = ForwardRef$5B;
const CopyIcon = ForwardRef$5C;
const CopyrightIcon = ForwardRef$5D;
const CornerDownLeftIcon = ForwardRef$5E;
const CornerDownRightAltIcon = ForwardRef$5F;
const CornerDownRightIcon = ForwardRef$5G;
const CornerLeftDownIcon = ForwardRef$5H;
const CornerRightDownIcon = ForwardRef$5I;
const CornerUpLeftAltIcon = ForwardRef$5J;
const CornerUpLeftIcon = ForwardRef$5K;
const CornerUpRightAltIcon = ForwardRef$5L;
const CornerUpRightIcon = ForwardRef$5M;
const CoronavirusIcon = ForwardRef$5N;
const CreateDashboardIcon = ForwardRef$5O;
const CreativeCommonsPdIcon = ForwardRef$5P;
const CreditCardSearchIcon = ForwardRef$5Q;
const CreditCardIcon = ForwardRef$5R;
const CrockeryIcon = ForwardRef$5S;
const CropAltRotateLeftIcon = ForwardRef$5T;
const CropAltRotateRightIcon = ForwardRef$5U;
const CropAltIcon = ForwardRef$5V;
const CrosshairAltIcon = ForwardRef$5W;
const CrosshairIcon = ForwardRef$5X;
const CrosshairsIcon = ForwardRef$5Y;
const Css3SimpleIcon = ForwardRef$5Z;
const CubeIcon = ForwardRef$5_;
const DashboardIcon = ForwardRef$5$;
const DataSharingIcon = ForwardRef$60;
const DatabaseAltIcon = ForwardRef$61;
const DatabaseIcon = ForwardRef$62;
const DesertIcon = ForwardRef$63;
const DesktopAltSlashIcon = ForwardRef$64;
const DesktopAltIcon = ForwardRef$65;
const DesktopCloudAltIcon = ForwardRef$66;
const DesktopSlashIcon = ForwardRef$67;
const DesktopIcon = ForwardRef$68;
const DialpadAltIcon = ForwardRef$69;
const DialpadIcon = ForwardRef$6a;
const DiamondIcon = ForwardRef$6b;
const DiaryAltIcon = ForwardRef$6c;
const DiaryIcon = ForwardRef$6d;
const DiceFiveIcon = ForwardRef$6e;
const DiceFourIcon = ForwardRef$6f;
const DiceOneIcon = ForwardRef$6g;
const DiceSixIcon = ForwardRef$6h;
const DiceThreeIcon = ForwardRef$6i;
const DiceTwoIcon = ForwardRef$6j;
const DirectionIcon = ForwardRef$6k;
const DirectionsIcon = ForwardRef$6l;
const DiscordIcon = ForwardRef$6m;
const DizzyMehIcon = ForwardRef$6n;
const DnaIcon = ForwardRef$6o;
const DocumentInfoIcon = ForwardRef$6p;
const DocumentLayoutCenterIcon = ForwardRef$6q;
const DocumentLayoutLeftIcon = ForwardRef$6r;
const DocumentLayoutRightIcon = ForwardRef$6s;
const DollarAltIcon = ForwardRef$6t;
const DollarSignAltIcon = ForwardRef$6u;
const DollarSignIcon = ForwardRef$6v;
const DownloadAltIcon = ForwardRef$6w;
const DraggabledotsIcon = ForwardRef$6x;
const DribbbleIcon = ForwardRef$6y;
const DrillIcon = ForwardRef$6z;
const DropboxIcon = ForwardRef$6A;
const DumbbellIcon = ForwardRef$6B;
const EarIcon = ForwardRef$6C;
const EditAltIcon = ForwardRef$6D;
const EditIcon = ForwardRef$6E;
const EllipsisHIcon = ForwardRef$6F;
const EllipsisVIcon = ForwardRef$6G;
const EmojiIcon = ForwardRef$6H;
const EnterIcon = ForwardRef$6I;
const EnvelopeAddIcon = ForwardRef$6J;
const EnvelopeAltIcon = ForwardRef$6K;
const EnvelopeBlockIcon = ForwardRef$6L;
const EnvelopeBookmarkIcon = ForwardRef$6M;
const EnvelopeCheckIcon = ForwardRef$6N;
const EnvelopeDownloadAltIcon = ForwardRef$6O;
const EnvelopeDownloadIcon = ForwardRef$6P;
const EnvelopeEditIcon = ForwardRef$6Q;
const EnvelopeExclamationIcon = ForwardRef$6R;
const EnvelopeHeartIcon = ForwardRef$6S;
const EnvelopeInfoIcon = ForwardRef$6T;
const EnvelopeLockIcon = ForwardRef$6U;
const EnvelopeMinusIcon = ForwardRef$6V;
const EnvelopeOpenIcon = ForwardRef$6W;
const EnvelopeQuestionIcon = ForwardRef$6X;
const EnvelopeReceiveIcon = ForwardRef$6Y;
const EnvelopeRedoIcon = ForwardRef$6Z;
const EnvelopeSearchIcon = ForwardRef$6_;
const EnvelopeSendIcon = ForwardRef$6$;
const EnvelopeShareIcon = ForwardRef$70;
const EnvelopeShieldIcon = ForwardRef$71;
const EnvelopeStarIcon = ForwardRef$72;
const EnvelopeTimesIcon = ForwardRef$73;
const EnvelopeUploadAltIcon = ForwardRef$74;
const EnvelopeUploadIcon = ForwardRef$75;
const EnvelopeIcon = ForwardRef$76;
const EnvelopesIcon = ForwardRef$77;
const EqualCircleIcon = ForwardRef$78;
const EuroCircleIcon = ForwardRef$79;
const EuroIcon = ForwardRef$7a;
const ExchangeAltIcon = ForwardRef$7b;
const ExchangeIcon = ForwardRef$7c;
const ExclamationCircleIcon = ForwardRef$7d;
const ExclamationOctagonIcon = ForwardRef$7e;
const ExclamationTriangleIcon = ForwardRef$7f;
const ExcludeIcon = ForwardRef$7g;
const ExitIcon = ForwardRef$7h;
const ExpandAltIcon = ForwardRef$7i;
const ExpandArrowsAltIcon = ForwardRef$7j;
const ExpandArrowsIcon = ForwardRef$7k;
const ExpandFromCornerIcon = ForwardRef$7l;
const ExpandLeftIcon = ForwardRef$7m;
const ExpandRightIcon = ForwardRef$7n;
const ExportIcon = ForwardRef$7o;
const ExposureAltIcon = ForwardRef$7p;
const ExposureIncreaseIcon = ForwardRef$7q;
const ExternalLinkAltIcon = ForwardRef$7r;
const EyeSlashIcon = ForwardRef$7s;
const EyeIcon = ForwardRef$7t;
const FacebookFIcon = ForwardRef$7u;
const FacebookMessengerAltIcon = ForwardRef$7v;
const FacebookMessengerIcon = ForwardRef$7w;
const FacebookIcon = ForwardRef$7x;
const FahrenheitIcon = ForwardRef$7y;
const FastMailAltIcon = ForwardRef$7z;
const FastMailIcon = ForwardRef$7A;
const FavoriteIcon = ForwardRef$7B;
const FeedbackIcon = ForwardRef$7C;
const FileAltIcon = ForwardRef$7D;
const FileBlankIcon = ForwardRef$7E;
const FileBlockAltIcon = ForwardRef$7F;
const FileBookmarkAltIcon = ForwardRef$7G;
const FileCheckAltIcon = ForwardRef$7H;
const FileCheckIcon = ForwardRef$7I;
const FileContractDollarIcon = ForwardRef$7J;
const FileCopyAltIcon = ForwardRef$7K;
const FileDownloadAltIcon = ForwardRef$7L;
const FileDownloadIcon = ForwardRef$7M;
const FileEditAltIcon = ForwardRef$7N;
const FileExclamationAltIcon = ForwardRef$7O;
const FileExclamationIcon = ForwardRef$7P;
const FileExportIcon = ForwardRef$7Q;
const FileGraphIcon = ForwardRef$7R;
const FileHeartIcon = ForwardRef$7S;
const FileImportIcon = ForwardRef$7T;
const FileInfoAltIcon = ForwardRef$7U;
const FileLandscapeAltIcon = ForwardRef$7V;
const FileLandscapeIcon = ForwardRef$7W;
const FileLanscapeSlashIcon = ForwardRef$7X;
const FileLockAltIcon = ForwardRef$7Y;
const FileMedicalAltIcon = ForwardRef$7Z;
const FileMedicalIcon = ForwardRef$7_;
const FileMinusAltIcon = ForwardRef$7$;
const FileMinusIcon = ForwardRef$80;
const FileNetworkIcon = ForwardRef$81;
const FilePlusAltIcon = ForwardRef$82;
const FilePlusIcon = ForwardRef$83;
const FileQuestionAltIcon = ForwardRef$84;
const FileQuestionIcon = ForwardRef$85;
const FileRedoAltIcon = ForwardRef$86;
const FileSearchAltIcon = ForwardRef$87;
const FileShareAltIcon = ForwardRef$88;
const FileShieldAltIcon = ForwardRef$89;
const FileSlashIcon = ForwardRef$8a;
const FileTimesAltIcon = ForwardRef$8b;
const FileTimesIcon = ForwardRef$8c;
const FileUploadAltIcon = ForwardRef$8d;
const FileUploadIcon = ForwardRef$8e;
const FileIcon = ForwardRef$8f;
const FilesLandscapesAltIcon = ForwardRef$8g;
const FilesLandscapesIcon = ForwardRef$8h;
const FilmIcon = ForwardRef$8i;
const FilterSlashIcon = ForwardRef$8j;
const FilterIcon = ForwardRef$8k;
const FireIcon = ForwardRef$8l;
const FlaskPotionIcon = ForwardRef$8m;
const FlaskIcon = ForwardRef$8n;
const FlipHAltIcon = ForwardRef$8o;
const FlipHIcon = ForwardRef$8p;
const FlipVAltIcon = ForwardRef$8q;
const FlipVIcon = ForwardRef$8r;
const FlowerIcon = ForwardRef$8s;
const FocusAddIcon = ForwardRef$8t;
const FocusTargetIcon = ForwardRef$8u;
const FocusIcon = ForwardRef$8v;
const FolderCheckIcon = ForwardRef$8w;
const FolderDownloadIcon = ForwardRef$8x;
const FolderExclamationIcon = ForwardRef$8y;
const FolderHeartIcon = ForwardRef$8z;
const FolderInfoIcon = ForwardRef$8A;
const FolderLockIcon = ForwardRef$8B;
const FolderMedicalIcon = ForwardRef$8C;
const FolderMinusIcon = ForwardRef$8D;
const FolderNetworkIcon = ForwardRef$8E;
const FolderOpenIcon = ForwardRef$8F;
const FolderPlusIcon = ForwardRef$8G;
const FolderQuestionIcon = ForwardRef$8H;
const FolderSlashIcon = ForwardRef$8I;
const FolderTimesIcon = ForwardRef$8J;
const FolderUploadIcon = ForwardRef$8K;
const FolderIcon = ForwardRef$8L;
const FootballAmericanIcon = ForwardRef$8M;
const FootballBallIcon = ForwardRef$8N;
const FootballIcon = ForwardRef$8O;
const ForecastcloudMoonTearIcon = ForwardRef$8P;
const ForwadedCallIcon = ForwardRef$8Q;
const ForwardIcon = ForwardRef$8R;
const FrownIcon = ForwardRef$8S;
const GameStructureIcon = ForwardRef$8T;
const GiftIcon = ForwardRef$8U;
const GithubAltIcon = ForwardRef$8V;
const GithubIcon = ForwardRef$8W;
const GlassMartiniAltSlashIcon = ForwardRef$8X;
const GlassMartiniAltIcon = ForwardRef$8Y;
const GlassMartiniIcon = ForwardRef$8Z;
const GlassTeaIcon = ForwardRef$8_;
const GlassIcon = ForwardRef$8$;
const GlobeIcon = ForwardRef$90;
const GoldIcon = ForwardRef$91;
const GolfBallIcon = ForwardRef$92;
const GoogleDriveAltIcon = ForwardRef$93;
const GoogleDriveIcon = ForwardRef$94;
const GoogleHangoutsAltIcon = ForwardRef$95;
const GoogleHangoutsIcon = ForwardRef$96;
const GooglePlayIcon = ForwardRef$97;
const GoogleIcon = ForwardRef$98;
const GraduationCapIcon = ForwardRef$99;
const GraphBarIcon = ForwardRef$9a;
const GridIcon = ForwardRef$9b;
const GridsIcon = ForwardRef$9c;
const GrinTongueWinkAltIcon = ForwardRef$9d;
const GrinTongueWinkIcon = ForwardRef$9e;
const GrinIcon = ForwardRef$9f;
const GripHorizontalLineIcon = ForwardRef$9g;
const HardHatIcon = ForwardRef$9h;
const HddIcon = ForwardRef$9i;
const HeadSideCoughIcon = ForwardRef$9j;
const HeadSideMaskIcon = ForwardRef$9k;
const HeadSideIcon = ForwardRef$9l;
const HeadphonesAltIcon = ForwardRef$9m;
const HeadphonesIcon = ForwardRef$9n;
const HeartAltIcon = ForwardRef$9o;
const HeartBreakIcon = ForwardRef$9p;
const HeartMedicalIcon = ForwardRef$9q;
const HeartRateIcon = ForwardRef$9r;
const HeartSignIcon = ForwardRef$9s;
const HeartIcon = ForwardRef$9t;
const HeartbeatIcon = ForwardRef$9u;
const HistoryAltIcon = ForwardRef$9v;
const HistoryIcon = ForwardRef$9w;
const HomeAltIcon = ForwardRef$9x;
const HomeIcon = ForwardRef$9y;
const HorizontalAlignCenterIcon = ForwardRef$9z;
const HorizontalAlignLeftIcon = ForwardRef$9A;
const HorizontalAlignRightIcon = ForwardRef$9B;
const HorizontalDistributionCenterIcon = ForwardRef$9C;
const HorizontalDistributionLeftIcon = ForwardRef$9D;
const HorizontalDistributionRightIcon = ForwardRef$9E;
const HospitalSquareSignIcon = ForwardRef$9F;
const HospitalSymbolIcon = ForwardRef$9G;
const HospitalIcon = ForwardRef$9H;
const HourglassIcon = ForwardRef$9I;
const HouseUserIcon = ForwardRef$9J;
const Html3AltIcon = ForwardRef$9K;
const Html3Icon = ForwardRef$9L;
const Html5AltIcon = ForwardRef$9M;
const Html5Icon = ForwardRef$9N;
const HuntingIcon = ForwardRef$9O;
const ImageAltSlashIcon = ForwardRef$9P;
const ImageBlockIcon = ForwardRef$9Q;
const ImageBrokenIcon = ForwardRef$9R;
const ImageCheckIcon = ForwardRef$9S;
const ImageDownloadIcon = ForwardRef$9T;
const ImageEditIcon = ForwardRef$9U;
const ImageLockIcon = ForwardRef$9V;
const ImageMinusIcon = ForwardRef$9W;
const ImagePlusIcon = ForwardRef$9X;
const ImageQuestionIcon = ForwardRef$9Y;
const ImageRedoIcon = ForwardRef$9Z;
const ImageResizeLandscapeIcon = ForwardRef$9_;
const ImageResizeSquareIcon = ForwardRef$9$;
const ImageSearchIcon = ForwardRef$a0;
const ImageShareIcon = ForwardRef$a1;
const ImageShieldIcon = ForwardRef$a2;
const ImageSlashIcon = ForwardRef$a3;
const ImageTimesIcon = ForwardRef$a4;
const ImageUploadIcon = ForwardRef$a5;
const ImageVIcon = ForwardRef$a6;
const ImageIcon = ForwardRef$a7;
const ImagesIcon = ForwardRef$a8;
const ImportIcon = ForwardRef$a9;
const IncomingCallIcon = ForwardRef$aa;
const InfoCircleIcon = ForwardRef$ab;
const InstagramAltIcon = ForwardRef$ac;
const InstagramIcon = ForwardRef$ad;
const IntercomAltIcon = ForwardRef$ae;
const IntercomIcon = ForwardRef$af;
const InvoiceIcon = ForwardRef$ag;
const ItalicIcon = ForwardRef$ah;
const JackhammerIcon = ForwardRef$ai;
const JavaScriptIcon = ForwardRef$aj;
const KayakIcon = ForwardRef$ak;
const KeySkeletonAltIcon = ForwardRef$al;
const KeySkeletonIcon = ForwardRef$am;
const KeyboardAltIcon = ForwardRef$an;
const KeyboardHideIcon = ForwardRef$ao;
const KeyboardShowIcon = ForwardRef$ap;
const KeyboardIcon = ForwardRef$aq;
const KeyholeCircleIcon = ForwardRef$ar;
const KeyholeSquareFullIcon = ForwardRef$as;
const KeyholeSquareIcon = ForwardRef$at;
const KidIcon = ForwardRef$au;
const LabelAltIcon = ForwardRef$av;
const LabelIcon = ForwardRef$aw;
const LampIcon = ForwardRef$ax;
const LaptopCloudIcon = ForwardRef$ay;
const LaptopConnectionIcon = ForwardRef$az;
const LaptopIcon = ForwardRef$aA;
const LaughingIcon = ForwardRef$aB;
const LayerGroupSlashIcon = ForwardRef$aC;
const LayerGroupIcon = ForwardRef$aD;
const LayersAltIcon = ForwardRef$aE;
const LayersSlashIcon = ForwardRef$aF;
const LayersIcon = ForwardRef$aG;
const LeftArrowFromLeftIcon = ForwardRef$aH;
const LeftArrowToLeftIcon = ForwardRef$aI;
const LeftIndentAltIcon = ForwardRef$aJ;
const LeftIndentIcon = ForwardRef$aK;
const LeftToRightTextDirectionIcon = ForwardRef$aL;
const LifeRingIcon = ForwardRef$aM;
const LightbulbAltIcon = ForwardRef$aN;
const LightbulbIcon = ForwardRef$aO;
const LineAltIcon = ForwardRef$aP;
const LineSpacingIcon = ForwardRef$aQ;
const LineIcon = ForwardRef$aR;
const LinkAddIcon = ForwardRef$aS;
const LinkAltIcon = ForwardRef$aT;
const LinkBrokenIcon = ForwardRef$aU;
const LinkHIcon = ForwardRef$aV;
const LinkIcon = ForwardRef$aW;
const LinkedinAltIcon = ForwardRef$aX;
const LinkedinIcon = ForwardRef$aY;
const LiraSignIcon = ForwardRef$aZ;
const ListUiAltIcon = ForwardRef$a_;
const ListUlIcon = ForwardRef$a$;
const LocationArrowAltIcon = ForwardRef$b0;
const LocationArrowIcon = ForwardRef$b1;
const LocationPinAltIcon = ForwardRef$b2;
const LocationPointIcon = ForwardRef$b3;
const LockAccessIcon = ForwardRef$b4;
const LockAltIcon = ForwardRef$b5;
const LockOpenAltIcon = ForwardRef$b6;
const LockSlashIcon = ForwardRef$b7;
const LockIcon = ForwardRef$b8;
const LuggageCartIcon = ForwardRef$b9;
const MailboxAltIcon = ForwardRef$ba;
const MailboxIcon = ForwardRef$bb;
const MapMarkerAltIcon = ForwardRef$bc;
const MapMarkerEditIcon = ForwardRef$bd;
const MapMarkerInfoIcon = ForwardRef$be;
const MapMarkerMinusIcon = ForwardRef$bf;
const MapMarkerPlusIcon = ForwardRef$bg;
const MapMarkerQuestionIcon = ForwardRef$bh;
const MapMarkerShieldIcon = ForwardRef$bi;
const MapMarkerSlashIcon = ForwardRef$bj;
const MapMarkerIcon = ForwardRef$bk;
const MapPinAltIcon = ForwardRef$bl;
const MapPinIcon = ForwardRef$bm;
const MapIcon = ForwardRef$bn;
const MarsIcon = ForwardRef$bo;
const MasterCardIcon = ForwardRef$bp;
const MaximizeLeftIcon = ForwardRef$bq;
const MedalIcon = ForwardRef$br;
const MedicalDripIcon = ForwardRef$bs;
const MedicalSquareFullIcon = ForwardRef$bt;
const MedicalSquareIcon = ForwardRef$bu;
const MedicalIcon = ForwardRef$bv;
const MediumMIcon = ForwardRef$bw;
const MedkitIcon = ForwardRef$bx;
const MeetingBoardIcon = ForwardRef$by;
const MegaphoneIcon = ForwardRef$bz;
const MehAltIcon = ForwardRef$bA;
const MehClosedEyeIcon = ForwardRef$bB;
const MehIcon = ForwardRef$bC;
const MessageIcon = ForwardRef$bD;
const MetroIcon = ForwardRef$bE;
const MicrophoneSlashIcon = ForwardRef$bF;
const MicrophoneIcon = ForwardRef$bG;
const MicroscopeIcon = ForwardRef$bH;
const MinusCircleIcon = ForwardRef$bI;
const MinusPathIcon = ForwardRef$bJ;
const MinusSquareFullIcon = ForwardRef$bK;
const MinusSquareIcon = ForwardRef$bL;
const MinusIcon = ForwardRef$bM;
const MissedCallIcon = ForwardRef$bN;
const MobileAndroidAltIcon = ForwardRef$bO;
const MobileAndroidIcon = ForwardRef$bP;
const MobileVibrateIcon = ForwardRef$bQ;
const ModemIcon = ForwardRef$bR;
const MoneyBillSlashIcon = ForwardRef$bS;
const MoneyBillStackIcon = ForwardRef$bT;
const MoneyBillIcon = ForwardRef$bU;
const MoneyInsertIcon = ForwardRef$bV;
const MoneyStackIcon = ForwardRef$bW;
const MoneyWithdrawIcon = ForwardRef$bX;
const MoneyWithdrawalIcon = ForwardRef$bY;
const MoneybagAltIcon = ForwardRef$bZ;
const MoneybagIcon = ForwardRef$b_;
const MonitorHeartRateIcon = ForwardRef$b$;
const MonitorIcon = ForwardRef$c0;
const MoonEclipseIcon = ForwardRef$c1;
const MoonIcon = ForwardRef$c2;
const MoonsetIcon = ForwardRef$c3;
const MountainsSunIcon = ForwardRef$c4;
const MountainsIcon = ForwardRef$c5;
const MouseAlt2Icon = ForwardRef$c6;
const MouseAltIcon = ForwardRef$c7;
const MouseIcon = ForwardRef$c8;
const MultiplyIcon = ForwardRef$c9;
const MusicNoteIcon = ForwardRef$ca;
const MusicTuneSlashIcon = ForwardRef$cb;
const MusicIcon = ForwardRef$cc;
const NAIcon = ForwardRef$cd;
const NavigatorIcon = ForwardRef$ce;
const NerdIcon = ForwardRef$cf;
const NewspaperIcon = ForwardRef$cg;
const NinjaIcon = ForwardRef$ch;
const NoEntryIcon = ForwardRef$ci;
const NotebooksIcon = ForwardRef$cj;
const NotesIcon = ForwardRef$ck;
const ObjectGroupIcon = ForwardRef$cl;
const ObjectUngroupIcon = ForwardRef$cm;
const OctagonIcon = ForwardRef$cn;
const OperaAltIcon = ForwardRef$co;
const OperaIcon = ForwardRef$cp;
const OutgoingCallIcon = ForwardRef$cq;
const PackageIcon = ForwardRef$cr;
const PadlockIcon = ForwardRef$cs;
const PaintToolIcon = ForwardRef$ct;
const PaletteIcon = ForwardRef$cu;
const PanelAddIcon = ForwardRef$cv;
const PanoramaHAltIcon = ForwardRef$cw;
const PanoramaHIcon = ForwardRef$cx;
const PanoramaVIcon = ForwardRef$cy;
const PaperclipIcon = ForwardRef$cz;
const ParagraphIcon = ForwardRef$cA;
const ParcelIcon = ForwardRef$cB;
const ParkingCircleIcon = ForwardRef$cC;
const ParkingSquareIcon = ForwardRef$cD;
const PathfinderUniteIcon = ForwardRef$cE;
const PathfinderIcon = ForwardRef$cF;
const PauseCircleIcon = ForwardRef$cG;
const PauseIcon = ForwardRef$cH;
const PaypalIcon = ForwardRef$cI;
const PenIcon = ForwardRef$cJ;
const PentagonIcon = ForwardRef$cK;
const PercentageIcon = ForwardRef$cL;
const PhoneAltIcon = ForwardRef$cM;
const PhonePauseIcon = ForwardRef$cN;
const PhoneSlashIcon = ForwardRef$cO;
const PhoneTimesIcon = ForwardRef$cP;
const PhoneVolumeIcon = ForwardRef$cQ;
const PhoneIcon = ForwardRef$cR;
const PictureIcon = ForwardRef$cS;
const PizzaSliceIcon = ForwardRef$cT;
const PlaneArrivalIcon = ForwardRef$cU;
const PlaneDepartureIcon = ForwardRef$cV;
const PlaneFlyIcon = ForwardRef$cW;
const PlaneIcon = ForwardRef$cX;
const PlayCircleIcon = ForwardRef$cY;
const PlayIcon = ForwardRef$cZ;
const PlugIcon = ForwardRef$c_;
const PlusCircleIcon = ForwardRef$c$;
const PlusSquareIcon = ForwardRef$d0;
const PlusIcon = ForwardRef$d1;
const PodiumIcon = ForwardRef$d2;
const PolygonIcon = ForwardRef$d3;
const PostStampIcon = ForwardRef$d4;
const PostcardIcon = ForwardRef$d5;
const PoundCircleIcon = ForwardRef$d6;
const PoundIcon = ForwardRef$d7;
const PowerIcon = ForwardRef$d8;
const PrescriptionBottleIcon = ForwardRef$d9;
const PresentationCheckIcon = ForwardRef$da;
const PresentationEditIcon = ForwardRef$db;
const PresentationLineIcon = ForwardRef$dc;
const PresentationLinesAltIcon = ForwardRef$dd;
const PresentationMinusIcon = ForwardRef$de;
const PresentationPlayIcon = ForwardRef$df;
const PresentationPlusIcon = ForwardRef$dg;
const PresentationTimesIcon = ForwardRef$dh;
const PresentationIcon = ForwardRef$di;
const PreviousIcon = ForwardRef$dj;
const PricetagAltIcon = ForwardRef$dk;
const PrintSlashIcon = ForwardRef$dl;
const PrintIcon = ForwardRef$dm;
const ProcessIcon = ForwardRef$dn;
const ProcessorIcon = ForwardRef$do;
const ProgrammingLanguageIcon = ForwardRef$dp;
const PumpIcon = ForwardRef$dq;
const PuzzlePieceIcon = ForwardRef$dr;
const QrcodeScanIcon = ForwardRef$ds;
const QuestionCircleIcon = ForwardRef$dt;
const RainbowIcon = ForwardRef$du;
const RaindropsAltIcon = ForwardRef$dv;
const RaindropsIcon = ForwardRef$dw;
const ReactIcon = ForwardRef$dx;
const ReceiptAltIcon = ForwardRef$dy;
const ReceiptIcon = ForwardRef$dz;
const RecordAudioIcon = ForwardRef$dA;
const RedditAlienAltIcon = ForwardRef$dB;
const RedoIcon = ForwardRef$dC;
const RefreshIcon = ForwardRef$dD;
const RegisteredIcon = ForwardRef$dE;
const RepeatIcon = ForwardRef$dF;
const RestaurantIcon = ForwardRef$dG;
const RightIndentAltIcon = ForwardRef$dH;
const RightToLeftTextDirectionIcon = ForwardRef$dI;
const RobotIcon = ForwardRef$dJ;
const RocketIcon = ForwardRef$dK;
const RopeWayIcon = ForwardRef$dL;
const Rotate360Icon = ForwardRef$dM;
const RssAltIcon = ForwardRef$dN;
const RssInterfaceIcon = ForwardRef$dO;
const RssIcon = ForwardRef$dP;
const RulerCombinedIcon = ForwardRef$dQ;
const RulerIcon = ForwardRef$dR;
const RupeeSignIcon = ForwardRef$dS;
const SadCryIcon = ForwardRef$dT;
const SadCryingIcon = ForwardRef$dU;
const SadDizzyIcon = ForwardRef$dV;
const SadSquintIcon = ForwardRef$dW;
const SadIcon = ForwardRef$dX;
const SanitizerAltIcon = ForwardRef$dY;
const SanitizerIcon = ForwardRef$dZ;
const SaveIcon = ForwardRef$d_;
const ScalingLeftIcon = ForwardRef$d$;
const ScalingRightIcon = ForwardRef$e0;
const SceneryIcon = ForwardRef$e1;
const ScheduleIcon = ForwardRef$e2;
const ScrewIcon = ForwardRef$e3;
const ScrollHIcon = ForwardRef$e4;
const ScrollIcon = ForwardRef$e5;
const SearchAltIcon = ForwardRef$e6;
const SearchMinusIcon = ForwardRef$e7;
const SearchPlusIcon = ForwardRef$e8;
const SearchIcon = ForwardRef$e9;
const SelfieIcon = ForwardRef$ea;
const ServerAltIcon = ForwardRef$eb;
const ServerConnectionIcon = ForwardRef$ec;
const ServerNetworkAltIcon = ForwardRef$ed;
const ServerNetworkIcon = ForwardRef$ee;
const ServerIcon = ForwardRef$ef;
const ServersIcon = ForwardRef$eg;
const ServicemarkIcon = ForwardRef$eh;
const SettingIcon = ForwardRef$ei;
const ShareAltIcon = ForwardRef$ej;
const ShareIcon = ForwardRef$ek;
const ShieldCheckIcon = ForwardRef$el;
const ShieldExclamationIcon = ForwardRef$em;
const ShieldPlusIcon = ForwardRef$en;
const ShieldQuestionIcon = ForwardRef$eo;
const ShieldSlashIcon = ForwardRef$ep;
const ShieldIcon = ForwardRef$eq;
const ShipIcon = ForwardRef$er;
const ShopIcon = ForwardRef$es;
const ShoppingBagIcon = ForwardRef$et;
const ShoppingBasketIcon = ForwardRef$eu;
const ShoppingCartAltIcon = ForwardRef$ev;
const ShoppingCartIcon = ForwardRef$ew;
const ShovelIcon = ForwardRef$ex;
const ShrinkIcon = ForwardRef$ey;
const ShuffleIcon = ForwardRef$ez;
const ShutterAltIcon = ForwardRef$eA;
const ShutterIcon = ForwardRef$eB;
const SickIcon = ForwardRef$eC;
const SigmaIcon = ForwardRef$eD;
const SignAltIcon = ForwardRef$eE;
const SignInAltIcon = ForwardRef$eF;
const SignLeftIcon = ForwardRef$eG;
const SignOutAltIcon = ForwardRef$eH;
const SignRightIcon = ForwardRef$eI;
const SignalAlt3Icon = ForwardRef$eJ;
const SignalAltIcon = ForwardRef$eK;
const SignalIcon = ForwardRef$eL;
const SigninIcon = ForwardRef$eM;
const SignoutIcon = ForwardRef$eN;
const SilenceIcon = ForwardRef$eO;
const SilentSquintIcon = ForwardRef$eP;
const SimCardIcon = ForwardRef$eQ;
const SitemapIcon = ForwardRef$eR;
const SkipForwardAltIcon = ForwardRef$eS;
const SkipForwardCircleIcon = ForwardRef$eT;
const SkipForwardIcon = ForwardRef$eU;
const SkypeAltIcon = ForwardRef$eV;
const SkypeIcon = ForwardRef$eW;
const SlackAltIcon = ForwardRef$eX;
const SlackIcon = ForwardRef$eY;
const SliderHRangeIcon = ForwardRef$eZ;
const SliderHIcon = ForwardRef$e_;
const SlidersVAltIcon = ForwardRef$e$;
const SlidersVIcon = ForwardRef$f0;
const SmileBeamIcon = ForwardRef$f1;
const SmileDizzyIcon = ForwardRef$f2;
const SmileSquintWinkAltIcon = ForwardRef$f3;
const SmileSquintWinkIcon = ForwardRef$f4;
const SmileWinkAltIcon = ForwardRef$f5;
const SmileWinkIcon = ForwardRef$f6;
const SmileIcon = ForwardRef$f7;
const SnapchatAltIcon = ForwardRef$f8;
const SnapchatGhostIcon = ForwardRef$f9;
const SnapchatSquareIcon = ForwardRef$fa;
const SnowFlakeIcon = ForwardRef$fb;
const SnowflakeAltIcon = ForwardRef$fc;
const SnowflakeIcon = ForwardRef$fd;
const SocialDistancingIcon = ForwardRef$fe;
const SortAmountDownIcon = ForwardRef$ff;
const SortAmountUpIcon = ForwardRef$fg;
const SortIcon = ForwardRef$fh;
const SortingIcon = ForwardRef$fi;
const SpaceKeyIcon = ForwardRef$fj;
const SpadeIcon = ForwardRef$fk;
const SpermsIcon = ForwardRef$fl;
const SpinIcon = ForwardRef$fm;
const SquareFullIcon = ForwardRef$fn;
const SquareShapeIcon = ForwardRef$fo;
const SquareIcon = ForwardRef$fp;
const SquintIcon = ForwardRef$fq;
const StarHalfAltIcon = ForwardRef$fr;
const StarIcon = ForwardRef$fs;
const StepBackwardAltIcon = ForwardRef$ft;
const StepBackwardCircleIcon = ForwardRef$fu;
const StepBackwardIcon = ForwardRef$fv;
const StepForwardIcon = ForwardRef$fw;
const StethoscopeAltIcon = ForwardRef$fx;
const StethoscopeIcon = ForwardRef$fy;
const StopCircleIcon = ForwardRef$fz;
const StopwatchSlashIcon = ForwardRef$fA;
const StopwatchIcon = ForwardRef$fB;
const StoreAltIcon = ForwardRef$fC;
const StoreSlashIcon = ForwardRef$fD;
const StoreIcon = ForwardRef$fE;
const StreeringIcon = ForwardRef$fF;
const StretcherIcon = ForwardRef$fG;
const SubjectIcon = ForwardRef$fH;
const SubwayAltIcon = ForwardRef$fI;
const SubwayIcon = ForwardRef$fJ;
const SuitcaseAltIcon = ForwardRef$fK;
const SuitcaseIcon = ForwardRef$fL;
const SunIcon = ForwardRef$fM;
const SunsetIcon = ForwardRef$fN;
const SurpriseIcon = ForwardRef$fO;
const SwatchbookIcon = ForwardRef$fP;
const SwiggyIcon = ForwardRef$fQ;
const SwimmerIcon = ForwardRef$fR;
const SyncExclamationIcon = ForwardRef$fS;
const SyncSlashIcon = ForwardRef$fT;
const SyncIcon = ForwardRef$fU;
const SyringeIcon = ForwardRef$fV;
const TableTennisIcon = ForwardRef$fW;
const TableIcon = ForwardRef$fX;
const TabletIcon = ForwardRef$fY;
const TabletsIcon = ForwardRef$fZ;
const TachometerFastAltIcon = ForwardRef$f_;
const TachometerFastIcon = ForwardRef$f$;
const TagAltIcon = ForwardRef$g0;
const TagIcon = ForwardRef$g1;
const TapeIcon = ForwardRef$g2;
const TaxiIcon = ForwardRef$g3;
const TearIcon = ForwardRef$g4;
const TelegramAltIcon = ForwardRef$g5;
const TelegramIcon = ForwardRef$g6;
const TelescopeIcon = ForwardRef$g7;
const TemperatureEmptyIcon = ForwardRef$g8;
const TemperatureHalfIcon = ForwardRef$g9;
const TemperatureMinusIcon = ForwardRef$ga;
const TemperaturePlusIcon = ForwardRef$gb;
const TemperatureQuarterIcon = ForwardRef$gc;
const TemperatureThreeQuarterIcon = ForwardRef$gd;
const TemperatureIcon = ForwardRef$ge;
const TennisBallIcon = ForwardRef$gf;
const TextFieldsIcon = ForwardRef$gg;
const TextSizeIcon = ForwardRef$gh;
const TextStrikeThroughIcon = ForwardRef$gi;
const TextIcon = ForwardRef$gj;
const ThLargeIcon = ForwardRef$gk;
const ThSlashIcon = ForwardRef$gl;
const ThIcon = ForwardRef$gm;
const ThermometerIcon = ForwardRef$gn;
const ThumbsDownIcon = ForwardRef$go;
const ThumbsUpIcon = ForwardRef$gp;
const ThunderstormMoonIcon = ForwardRef$gq;
const ThunderstormSunIcon = ForwardRef$gr;
const ThunderstormIcon = ForwardRef$gs;
const TicketIcon = ForwardRef$gt;
const TimesCircleIcon = ForwardRef$gu;
const TimesSquareIcon = ForwardRef$gv;
const TimesIcon = ForwardRef$gw;
const ToggleOffIcon = ForwardRef$gx;
const ToggleOnIcon = ForwardRef$gy;
const ToiletPaperIcon = ForwardRef$gz;
const TopArrowFromTopIcon = ForwardRef$gA;
const TopArrowToTopIcon = ForwardRef$gB;
const TornadoIcon = ForwardRef$gC;
const TrademarkCircleIcon = ForwardRef$gD;
const TrademarkIcon = ForwardRef$gE;
const TrafficBarrierIcon = ForwardRef$gF;
const TrafficLightIcon = ForwardRef$gG;
const TransactionIcon = ForwardRef$gH;
const TrashAltIcon = ForwardRef$gI;
const TrashIcon = ForwardRef$gJ;
const TreesIcon = ForwardRef$gK;
const TriangleIcon = ForwardRef$gL;
const TrophyIcon = ForwardRef$gM;
const TrowelIcon = ForwardRef$gN;
const TruckLoadingIcon = ForwardRef$gO;
const TruckIcon = ForwardRef$gP;
const TumblrAltIcon = ForwardRef$gQ;
const TumblrSquareIcon = ForwardRef$gR;
const TumblrIcon = ForwardRef$gS;
const TvRetroSlashIcon = ForwardRef$gT;
const TvRetroIcon = ForwardRef$gU;
const TwitterAltIcon = ForwardRef$gV;
const TwitterIcon = ForwardRef$gW;
const UmbrellaIcon = ForwardRef$gX;
const UnamusedIcon = ForwardRef$gY;
const UnderlineIcon = ForwardRef$gZ;
const UniversityIcon = ForwardRef$g_;
const UnlockAltIcon = ForwardRef$g$;
const UnlockIcon = ForwardRef$h0;
const UploadAltIcon = ForwardRef$h1;
const UploadIcon = ForwardRef$h2;
const UsdCircleIcon = ForwardRef$h3;
const UsdSquareIcon = ForwardRef$h4;
const UserArrowsIcon = ForwardRef$h5;
const UserCheckIcon = ForwardRef$h6;
const UserCircleIcon = ForwardRef$h7;
const UserExclamationIcon = ForwardRef$h8;
const UserLocationIcon = ForwardRef$h9;
const UserMdIcon = ForwardRef$ha;
const UserMinusIcon = ForwardRef$hb;
const UserNurseIcon = ForwardRef$hc;
const UserPlusIcon = ForwardRef$hd;
const UserSquareIcon = ForwardRef$he;
const UserTimesIcon = ForwardRef$hf;
const UserIcon = ForwardRef$hg;
const UsersAltIcon = ForwardRef$hh;
const UtensilsAltIcon = ForwardRef$hi;
const UtensilsIcon = ForwardRef$hj;
const VectorSquareAltIcon = ForwardRef$hk;
const VectorSquareIcon = ForwardRef$hl;
const VenusIcon = ForwardRef$hm;
const VerticalAlignBottomIcon = ForwardRef$hn;
const VerticalAlignCenterIcon = ForwardRef$ho;
const VerticalAlignTopIcon = ForwardRef$hp;
const VerticalDistributeBottomIcon = ForwardRef$hq;
const VerticalDistributionCenterIcon = ForwardRef$hr;
const VerticalDistributionTopIcon = ForwardRef$hs;
const VideoSlashIcon = ForwardRef$ht;
const VideoIcon = ForwardRef$hu;
const VirusSlashIcon = ForwardRef$hv;
const VisualStudioIcon = ForwardRef$hw;
const VkAltIcon = ForwardRef$hx;
const VkIcon = ForwardRef$hy;
const VoicemailRectangleIcon = ForwardRef$hz;
const VoicemailIcon = ForwardRef$hA;
const VolumeDownIcon = ForwardRef$hB;
const VolumeMuteIcon = ForwardRef$hC;
const VolumeOffIcon = ForwardRef$hD;
const VolumeUpIcon = ForwardRef$hE;
const VolumeIcon = ForwardRef$hF;
const VuejsAltIcon = ForwardRef$hG;
const VuejsIcon = ForwardRef$hH;
const WallIcon = ForwardRef$hI;
const WalletIcon = ForwardRef$hJ;
const WatchAltIcon = ForwardRef$hK;
const WatchIcon = ForwardRef$hL;
const WaterDropSlashIcon = ForwardRef$hM;
const WaterGlassIcon = ForwardRef$hN;
const WaterIcon = ForwardRef$hO;
const WebGridAltIcon = ForwardRef$hP;
const WebGridIcon = ForwardRef$hQ;
const WebSectionAltIcon = ForwardRef$hR;
const WebSectionIcon = ForwardRef$hS;
const WebcamIcon = ForwardRef$hT;
const WeightIcon = ForwardRef$hU;
const WhatsappAltIcon = ForwardRef$hV;
const WhatsappIcon = ForwardRef$hW;
const WheelBarrowIcon = ForwardRef$hX;
const WheelchairAltIcon = ForwardRef$hY;
const WheelchairIcon = ForwardRef$hZ;
const WifiRouterIcon = ForwardRef$h_;
const WifiSlashIcon = ForwardRef$h$;
const WifiIcon = ForwardRef$i0;
const WindMoonIcon = ForwardRef$i1;
const WindSunIcon = ForwardRef$i2;
const WindIcon = ForwardRef$i3;
const WindowGridIcon = ForwardRef$i4;
const WindowMaximizeIcon = ForwardRef$i5;
const WindowSectionIcon = ForwardRef$i6;
const WindowIcon = ForwardRef$i7;
const WindsockIcon = ForwardRef$i8;
const WindyIcon = ForwardRef$i9;
const WordpressSimpleIcon = ForwardRef$ia;
const WordpressIcon = ForwardRef$ib;
const WrapTextIcon = ForwardRef$ic;
const WrenchIcon = ForwardRef$id;
const XAddIcon = ForwardRef$ie;
const XIcon = ForwardRef$if;
const YenCircleIcon = ForwardRef$ig;
const YenIcon = ForwardRef$ih;
const YinYangIcon = ForwardRef$ii;
const YoutubeIcon = ForwardRef$ij;

export { AbacusIcon, AccessibleIconAltIcon, AdjustAltIcon, AdjustCircleIcon, AdjustHalfIcon, AdjustIcon, AdobeAltIcon, AdobeIcon, AirplayIcon, AlignAltIcon, AlignCenterAltIcon, AlignCenterHIcon, AlignCenterIcon, AlignCenterJustifyIcon, AlignCenterVIcon, AlignIcon, AlignJustifyIcon, AlignLeftIcon, AlignLeftJustifyIcon, AlignLetterRightIcon, AlignRightIcon, AlignRightJustifyIcon, AmazonIcon, AmbulanceIcon, AnalysisIcon, AnalyticsIcon, AnchorIcon, AndroidAltIcon, AndroidIcon, AndroidPhoneSlashIcon, AngleDoubleDownIcon, AngleDoubleLeftIcon, AngleDoubleRightIcon, AngleDoubleUpIcon, AngleDownIcon, AngleLeftBIcon, AngleLeftIcon, AngleRightBIcon, AngleRightIcon, AngleUpIcon, AngryIcon, AnkhIcon, AnnoyedAltIcon, AnnoyedIcon, AppleAltIcon, AppleIcon, AppsIcon, ArchiveAltIcon, ArchiveIcon, ArchwayIcon, ArrowBreakIcon, ArrowCircleDownIcon, ArrowCircleLeftIcon, ArrowCircleRightIcon, ArrowCircleUpIcon, ArrowCompressHIcon, ArrowDownIcon, ArrowDownLeftIcon, ArrowDownRightIcon, ArrowFromRightIcon, ArrowFromTopIcon, ArrowGrowthIcon, ArrowIcon, ArrowLeftIcon, ArrowRandomIcon, ArrowResizeDiagonalIcon, ArrowRightIcon, ArrowToBottomIcon, ArrowToRightIcon, ArrowUpIcon, ArrowUpLeftIcon, ArrowUpRightIcon, ArrowsHAltIcon, ArrowsHIcon, ArrowsLeftDownIcon, ArrowsMaximizeIcon, ArrowsMergeIcon, ArrowsResizeHIcon, ArrowsResizeIcon, ArrowsResizeVIcon, ArrowsRightDownIcon, ArrowsShrinkHIcon, ArrowsShrinkVIcon, ArrowsUpRightIcon, ArrowsVAltIcon, ArrowsVIcon, AssistiveListeningSystemsIcon, AsteriskIcon, AtIcon, AtomIcon, AutoFlashIcon, AwardAltIcon, AwardIcon, BabyCarriageIcon, BackpackIcon, BackspaceIcon, BackwardIcon, BagAltIcon, BagIcon, BagSlashIcon, BalanceScaleIcon, BanIcon, BandAidIcon, BarsIcon, BaseballBallIcon, BasketballHoopIcon, BasketballIcon, BathIcon, BatteryBoltIcon, BatteryEmptyIcon, BedDoubleIcon, BedIcon, BehanceAltIcon, BehanceIcon, BellIcon, BellSchoolIcon, BellSlashIcon, BillIcon, BingIcon, BitcoinAltIcon, BitcoinCircleIcon, BitcoinIcon, BitcoinSignIcon, BlackBerryIcon, BloggerAltIcon, BloggerIcon, BluetoothBIcon, BoldIcon, BoltAltIcon, BoltIcon, BoltSlashIcon, BookAltIcon, BookIcon, BookMedicalIcon, BookOpenIcon, BookReaderIcon, BookmarkFullIcon, BookmarkIcon, BooksIcon, BoomboxIcon, BorderAltIcon, BorderBottomIcon, BorderClearIcon, BorderHorizontalIcon, BorderInnerIcon, BorderLeftIcon, BorderOutIcon, BorderRightIcon, BorderTopIcon, BorderVerticalIcon, BowlingBallIcon, BoxIcon, BracketsCurlyIcon, BrainIcon, BriefcaseAltIcon, BriefcaseIcon, BrightIcon, BrightnessEmptyIcon, BrightnessHalfIcon, BrightnessIcon, BrightnessLowIcon, BrightnessMinusIcon, BrightnessPlusIcon, BringBottomIcon, BringFrontIcon, BrowserIcon, BrushAltIcon, BugIcon, BuildingIcon, BulletIcon, BullseyeIcon, BusAltIcon, BusIcon, BusSchoolIcon, CalculatorAltIcon, CalculatorIcon, CalendarAltIcon, CalendarSlashIcon, CalenderIcon, CallingIcon, CameraChangeIcon, CameraIcon, CameraPlusIcon, CameraSlashIcon, CancelIcon, CapsuleIcon, CaptureIcon, CarIcon, CarSideviewIcon, CarSlashIcon, CarWashIcon, CardAtmIcon, CaretRightIcon, CellIcon, CelsiusIcon, ChannelAddIcon, ChannelIcon, ChartBarAltIcon, ChartBarIcon, ChartDownIcon, ChartGrowthAltIcon, ChartGrowthIcon, ChartIcon, ChartLineIcon, ChartPieAltIcon, ChartPieIcon, ChatBubbleUserIcon, ChatIcon, ChatInfoIcon, CheckCircleIcon, CheckIcon, CheckSquareIcon, CircleIcon, CircleLayerIcon, CircuitIcon, ClapperBoardIcon, ClinicMedicalIcon, ClipboardAltIcon, ClipboardBlankIcon, ClipboardIcon, ClipboardNotesIcon, ClockEightIcon, ClockFiveIcon, ClockIcon, ClockNineIcon, ClockSevenIcon, ClockTenIcon, ClockThreeIcon, ClockTwoIcon, ClosedCaptioningIcon, ClosedCaptioningSlashIcon, CloudBlockIcon, CloudBookmarkIcon, CloudCheckIcon, CloudComputingIcon, CloudDataConnectionIcon, CloudDatabaseTreeIcon, CloudDownloadIcon, CloudDrizzleIcon, CloudExclamationIcon, CloudHailIcon, CloudHeartIcon, CloudIcon, CloudInfoIcon, CloudLockIcon, CloudMeatballIcon, CloudMoonHailIcon, CloudMoonIcon, CloudMoonMeatballIcon, CloudMoonRainIcon, CloudMoonShowersIcon, CloudQuestionIcon, CloudRainIcon, CloudRainSunIcon, CloudRedoIcon, CloudShareIcon, CloudShieldIcon, CloudShowersAltIcon, CloudShowersHeavyIcon, CloudShowersIcon, CloudSlashIcon, CloudSunHailIcon, CloudSunIcon, CloudSunMeatballIcon, CloudSunRainAltIcon, CloudSunRainIcon, CloudSunTearIcon, CloudTimesIcon, CloudUnlockIcon, CloudUploadIcon, CloudWifiIcon, CloudWindIcon, CloudsIcon, ClubIcon, CodeBranchIcon, CoffeeIcon, CogIcon, CoinsIcon, ColumnsIcon, CommentAddIcon, CommentAltBlockIcon, CommentAltChartLinesIcon, CommentAltCheckIcon, CommentAltDotsIcon, CommentAltDownloadIcon, CommentAltEditIcon, CommentAltExclamationIcon, CommentAltHeartIcon, CommentAltIcon, CommentAltImageIcon, CommentAltInfoIcon, CommentAltLinesIcon, CommentAltLockIcon, CommentAltMedicalIcon, CommentAltMessageIcon, CommentAltNotesIcon, CommentAltPlusIcon, CommentAltQuestionIcon, CommentAltRedoIcon, CommentAltSearchIcon, CommentAltShareIcon, CommentAltShieldIcon, CommentAltSlashIcon, CommentAltUploadIcon, CommentAltVerifyIcon, CommentBlockIcon, CommentChartLineIcon, CommentCheckIcon, CommentDotsIcon, CommentDownloadIcon, CommentEditIcon, CommentExclamationIcon, CommentHeartIcon, CommentIcon, CommentImageIcon, CommentInfoAltIcon, CommentInfoIcon, CommentLinesIcon, CommentLockIcon, CommentMedicalIcon, CommentMessageIcon, CommentNotesIcon, CommentPlusIcon, CommentQuestionIcon, CommentRedoIcon, CommentSearchIcon, CommentShareIcon, CommentShieldIcon, CommentSlashIcon, CommentUploadIcon, CommentVerifyIcon, CommentsAltIcon, CommentsIcon, CompactDiscIcon, ComparisonIcon, CompassIcon, CompressAltIcon, CompressAltLeftIcon, CompressArrowsIcon, CompressIcon, CompressLinesIcon, CompressPointIcon, CompressVIcon, ConfusedIcon, ConstructorIcon, CopyAltIcon, CopyIcon, CopyLandscapeIcon, CopyrightIcon, CornerDownLeftIcon, CornerDownRightAltIcon, CornerDownRightIcon, CornerLeftDownIcon, CornerRightDownIcon, CornerUpLeftAltIcon, CornerUpLeftIcon, CornerUpRightAltIcon, CornerUpRightIcon, CoronavirusIcon, CreateDashboardIcon, CreativeCommonsPdIcon, CreditCardIcon, CreditCardSearchIcon, CrockeryIcon, CropAltIcon, CropAltRotateLeftIcon, CropAltRotateRightIcon, CrosshairAltIcon, CrosshairIcon, CrosshairsIcon, Css3SimpleIcon, CubeIcon, DashboardIcon, DataSharingIcon, DatabaseAltIcon, DatabaseIcon, DesertIcon, DesktopAltIcon, DesktopAltSlashIcon, DesktopCloudAltIcon, DesktopIcon, DesktopSlashIcon, DialpadAltIcon, DialpadIcon, DiamondIcon, DiaryAltIcon, DiaryIcon, DiceFiveIcon, DiceFourIcon, DiceOneIcon, DiceSixIcon, DiceThreeIcon, DiceTwoIcon, DirectionIcon, DirectionsIcon, DiscordIcon, DizzyMehIcon, DnaIcon, DocumentInfoIcon, DocumentLayoutCenterIcon, DocumentLayoutLeftIcon, DocumentLayoutRightIcon, DollarAltIcon, DollarSignAltIcon, DollarSignIcon, DownloadAltIcon, DraggabledotsIcon, DribbbleIcon, DrillIcon, DropboxIcon, DumbbellIcon, EarIcon, EditAltIcon, EditIcon, EllipsisHIcon, EllipsisVIcon, EmojiIcon, EnterIcon, EnvelopeAddIcon, EnvelopeAltIcon, EnvelopeBlockIcon, EnvelopeBookmarkIcon, EnvelopeCheckIcon, EnvelopeDownloadAltIcon, EnvelopeDownloadIcon, EnvelopeEditIcon, EnvelopeExclamationIcon, EnvelopeHeartIcon, EnvelopeIcon, EnvelopeInfoIcon, EnvelopeLockIcon, EnvelopeMinusIcon, EnvelopeOpenIcon, EnvelopeQuestionIcon, EnvelopeReceiveIcon, EnvelopeRedoIcon, EnvelopeSearchIcon, EnvelopeSendIcon, EnvelopeShareIcon, EnvelopeShieldIcon, EnvelopeStarIcon, EnvelopeTimesIcon, EnvelopeUploadAltIcon, EnvelopeUploadIcon, EnvelopesIcon, EqualCircleIcon, EuroCircleIcon, EuroIcon, ExchangeAltIcon, ExchangeIcon, ExclamationCircleIcon, ExclamationOctagonIcon, ExclamationTriangleIcon, ExcludeIcon, ExitIcon, ExpandAltIcon, ExpandArrowsAltIcon, ExpandArrowsIcon, ExpandFromCornerIcon, ExpandLeftIcon, ExpandRightIcon, ExportIcon, ExposureAltIcon, ExposureIncreaseIcon, ExternalLinkAltIcon, EyeIcon, EyeSlashIcon, FacebookFIcon, FacebookIcon, FacebookMessengerAltIcon, FacebookMessengerIcon, FahrenheitIcon, FastMailAltIcon, FastMailIcon, FavoriteIcon, FeedbackIcon, FileAltIcon, FileBlankIcon, FileBlockAltIcon, FileBookmarkAltIcon, FileCheckAltIcon, FileCheckIcon, FileContractDollarIcon, FileCopyAltIcon, FileDownloadAltIcon, FileDownloadIcon, FileEditAltIcon, FileExclamationAltIcon, FileExclamationIcon, FileExportIcon, FileGraphIcon, FileHeartIcon, FileIcon, FileImportIcon, FileInfoAltIcon, FileLandscapeAltIcon, FileLandscapeIcon, FileLanscapeSlashIcon, FileLockAltIcon, FileMedicalAltIcon, FileMedicalIcon, FileMinusAltIcon, FileMinusIcon, FileNetworkIcon, FilePlusAltIcon, FilePlusIcon, FileQuestionAltIcon, FileQuestionIcon, FileRedoAltIcon, FileSearchAltIcon, FileShareAltIcon, FileShieldAltIcon, FileSlashIcon, FileTimesAltIcon, FileTimesIcon, FileUploadAltIcon, FileUploadIcon, FilesLandscapesAltIcon, FilesLandscapesIcon, FilmIcon, FilterIcon, FilterSlashIcon, FireIcon, FlaskIcon, FlaskPotionIcon, FlipHAltIcon, FlipHIcon, FlipVAltIcon, FlipVIcon, FlowerIcon, FocusAddIcon, FocusIcon, FocusTargetIcon, FolderCheckIcon, FolderDownloadIcon, FolderExclamationIcon, FolderHeartIcon, FolderIcon, FolderInfoIcon, FolderLockIcon, FolderMedicalIcon, FolderMinusIcon, FolderNetworkIcon, FolderOpenIcon, FolderPlusIcon, FolderQuestionIcon, FolderSlashIcon, FolderTimesIcon, FolderUploadIcon, FootballAmericanIcon, FootballBallIcon, FootballIcon, ForecastcloudMoonTearIcon, ForwadedCallIcon, ForwardIcon, FrownIcon, GameStructureIcon, GiftIcon, GithubAltIcon, GithubIcon, GlassIcon, GlassMartiniAltIcon, GlassMartiniAltSlashIcon, GlassMartiniIcon, GlassTeaIcon, GlobeIcon, GoldIcon, GolfBallIcon, GoogleDriveAltIcon, GoogleDriveIcon, GoogleHangoutsAltIcon, GoogleHangoutsIcon, GoogleIcon, GooglePlayIcon, GraduationCapIcon, GraphBarIcon, GridIcon, GridsIcon, GrinIcon, GrinTongueWinkAltIcon, GrinTongueWinkIcon, GripHorizontalLineIcon, HardHatIcon, HddIcon, HeadSideCoughIcon, HeadSideIcon, HeadSideMaskIcon, HeadphonesAltIcon, HeadphonesIcon, HeartAltIcon, HeartBreakIcon, HeartIcon, HeartMedicalIcon, HeartRateIcon, HeartSignIcon, HeartbeatIcon, HistoryAltIcon, HistoryIcon, HomeAltIcon, HomeIcon, HorizontalAlignCenterIcon, HorizontalAlignLeftIcon, HorizontalAlignRightIcon, HorizontalDistributionCenterIcon, HorizontalDistributionLeftIcon, HorizontalDistributionRightIcon, HospitalIcon, HospitalSquareSignIcon, HospitalSymbolIcon, HourglassIcon, HouseUserIcon, Html3AltIcon, Html3Icon, Html5AltIcon, Html5Icon, HuntingIcon, ImageAltSlashIcon, ImageBlockIcon, ImageBrokenIcon, ImageCheckIcon, ImageDownloadIcon, ImageEditIcon, ImageIcon, ImageLockIcon, ImageMinusIcon, ImagePlusIcon, ImageQuestionIcon, ImageRedoIcon, ImageResizeLandscapeIcon, ImageResizeSquareIcon, ImageSearchIcon, ImageShareIcon, ImageShieldIcon, ImageSlashIcon, ImageTimesIcon, ImageUploadIcon, ImageVIcon, ImagesIcon, ImportIcon, IncomingCallIcon, InfoCircleIcon, InstagramAltIcon, InstagramIcon, IntercomAltIcon, IntercomIcon, InvoiceIcon, ItalicIcon, JackhammerIcon, JavaScriptIcon, KayakIcon, KeySkeletonAltIcon, KeySkeletonIcon, KeyboardAltIcon, KeyboardHideIcon, KeyboardIcon, KeyboardShowIcon, KeyholeCircleIcon, KeyholeSquareFullIcon, KeyholeSquareIcon, KidIcon, LabelAltIcon, LabelIcon, LampIcon, LaptopCloudIcon, LaptopConnectionIcon, LaptopIcon, LaughingIcon, LayerGroupIcon, LayerGroupSlashIcon, LayersAltIcon, LayersIcon, LayersSlashIcon, LeftArrowFromLeftIcon, LeftArrowToLeftIcon, LeftIndentAltIcon, LeftIndentIcon, LeftToRightTextDirectionIcon, LifeRingIcon, LightbulbAltIcon, LightbulbIcon, LineAltIcon, LineIcon, LineSpacingIcon, LinkAddIcon, LinkAltIcon, LinkBrokenIcon, LinkHIcon, LinkIcon, LinkedinAltIcon, LinkedinIcon, LiraSignIcon, ListUiAltIcon, ListUlIcon, LocationArrowAltIcon, LocationArrowIcon, LocationPinAltIcon, LocationPointIcon, LockAccessIcon, LockAltIcon, LockIcon, LockOpenAltIcon, LockSlashIcon, LuggageCartIcon, MailboxAltIcon, MailboxIcon, MapIcon, MapMarkerAltIcon, MapMarkerEditIcon, MapMarkerIcon, MapMarkerInfoIcon, MapMarkerMinusIcon, MapMarkerPlusIcon, MapMarkerQuestionIcon, MapMarkerShieldIcon, MapMarkerSlashIcon, MapPinAltIcon, MapPinIcon, MarsIcon, MasterCardIcon, MaximizeLeftIcon, MedalIcon, MedicalDripIcon, MedicalIcon, MedicalSquareFullIcon, MedicalSquareIcon, MediumMIcon, MedkitIcon, MeetingBoardIcon, MegaphoneIcon, MehAltIcon, MehClosedEyeIcon, MehIcon, MessageIcon, MetroIcon, MicrophoneIcon, MicrophoneSlashIcon, MicroscopeIcon, MinusCircleIcon, MinusIcon, MinusPathIcon, MinusSquareFullIcon, MinusSquareIcon, MissedCallIcon, MobileAndroidAltIcon, MobileAndroidIcon, MobileVibrateIcon, ModemIcon, MoneyBillIcon, MoneyBillSlashIcon, MoneyBillStackIcon, MoneyInsertIcon, MoneyStackIcon, MoneyWithdrawIcon, MoneyWithdrawalIcon, MoneybagAltIcon, MoneybagIcon, MonitorHeartRateIcon, MonitorIcon, MoonEclipseIcon, MoonIcon, MoonsetIcon, MountainsIcon, MountainsSunIcon, MouseAlt2Icon, MouseAltIcon, MouseIcon, MultiplyIcon, MusicIcon, MusicNoteIcon, MusicTuneSlashIcon, NAIcon, NavigatorIcon, NerdIcon, NewspaperIcon, NinjaIcon, NoEntryIcon, NotebooksIcon, NotesIcon, ObjectGroupIcon, ObjectUngroupIcon, OctagonIcon, OperaAltIcon, OperaIcon, OutgoingCallIcon, PackageIcon, PadlockIcon, PaintToolIcon, PaletteIcon, PanelAddIcon, PanoramaHAltIcon, PanoramaHIcon, PanoramaVIcon, PaperclipIcon, ParagraphIcon, ParcelIcon, ParkingCircleIcon, ParkingSquareIcon, PathfinderIcon, PathfinderUniteIcon, PauseCircleIcon, PauseIcon, PaypalIcon, PenIcon, PentagonIcon, PercentageIcon, PhoneAltIcon, PhoneIcon, PhonePauseIcon, PhoneSlashIcon, PhoneTimesIcon, PhoneVolumeIcon, PictureIcon, PizzaSliceIcon, PlaneArrivalIcon, PlaneDepartureIcon, PlaneFlyIcon, PlaneIcon, PlayCircleIcon, PlayIcon, PlugIcon, Plus0Icon, Plus10Icon, Plus12Icon, Plus13Icon, Plus16Icon, Plus17Icon, Plus18Icon, Plus21Icon, Plus3Icon, Plus6Icon, PlusCircleIcon, PlusIcon, PlusSquareIcon, PodiumIcon, PolygonIcon, PostStampIcon, PostcardIcon, PoundCircleIcon, PoundIcon, PowerIcon, PrescriptionBottleIcon, PresentationCheckIcon, PresentationEditIcon, PresentationIcon, PresentationLineIcon, PresentationLinesAltIcon, PresentationMinusIcon, PresentationPlayIcon, PresentationPlusIcon, PresentationTimesIcon, PreviousIcon, PricetagAltIcon, PrintIcon, PrintSlashIcon, ProcessIcon, ProcessorIcon, ProgrammingLanguageIcon, PumpIcon, PuzzlePieceIcon, Px500Icon, QrcodeScanIcon, QuestionCircleIcon, RainbowIcon, RaindropsAltIcon, RaindropsIcon, ReactIcon, ReceiptAltIcon, ReceiptIcon, RecordAudioIcon, RedditAlienAltIcon, RedoIcon, RefreshIcon, RegisteredIcon, RepeatIcon, RestaurantIcon, RightIndentAltIcon, RightToLeftTextDirectionIcon, RobotIcon, RocketIcon, RopeWayIcon, Rotate360Icon, RssAltIcon, RssIcon, RssInterfaceIcon, RulerCombinedIcon, RulerIcon, RupeeSignIcon, SadCryIcon, SadCryingIcon, SadDizzyIcon, SadIcon, SadSquintIcon, SanitizerAltIcon, SanitizerIcon, SaveIcon, ScalingLeftIcon, ScalingRightIcon, SceneryIcon, ScheduleIcon, ScrewIcon, ScrollHIcon, ScrollIcon, SearchAltIcon, SearchIcon, SearchMinusIcon, SearchPlusIcon, SelfieIcon, ServerAltIcon, ServerConnectionIcon, ServerIcon, ServerNetworkAltIcon, ServerNetworkIcon, ServersIcon, ServicemarkIcon, SettingIcon, ShareAltIcon, ShareIcon, ShieldCheckIcon, ShieldExclamationIcon, ShieldIcon, ShieldPlusIcon, ShieldQuestionIcon, ShieldSlashIcon, ShipIcon, ShopIcon, ShoppingBagIcon, ShoppingBasketIcon, ShoppingCartAltIcon, ShoppingCartIcon, ShovelIcon, ShrinkIcon, ShuffleIcon, ShutterAltIcon, ShutterIcon, SickIcon, SigmaIcon, SignAltIcon, SignInAltIcon, SignLeftIcon, SignOutAltIcon, SignRightIcon, SignalAlt3Icon, SignalAltIcon, SignalIcon, SigninIcon, SignoutIcon, SilenceIcon, SilentSquintIcon, SimCardIcon, SitemapIcon, SkipForwardAltIcon, SkipForwardCircleIcon, SkipForwardIcon, SkypeAltIcon, SkypeIcon, SlackAltIcon, SlackIcon, SliderHIcon, SliderHRangeIcon, SlidersVAltIcon, SlidersVIcon, SmileBeamIcon, SmileDizzyIcon, SmileIcon, SmileSquintWinkAltIcon, SmileSquintWinkIcon, SmileWinkAltIcon, SmileWinkIcon, SnapchatAltIcon, SnapchatGhostIcon, SnapchatSquareIcon, SnowFlakeIcon, SnowflakeAltIcon, SnowflakeIcon, SocialDistancingIcon, SortAmountDownIcon, SortAmountUpIcon, SortIcon, SortingIcon, SpaceKeyIcon, SpadeIcon, SpermsIcon, SpinIcon, SquareFullIcon, SquareIcon, SquareShapeIcon, SquintIcon, StarHalfAltIcon, StarIcon, StepBackwardAltIcon, StepBackwardCircleIcon, StepBackwardIcon, StepForwardIcon, StethoscopeAltIcon, StethoscopeIcon, StopCircleIcon, StopwatchIcon, StopwatchSlashIcon, StoreAltIcon, StoreIcon, StoreSlashIcon, StreeringIcon, StretcherIcon, SubjectIcon, SubwayAltIcon, SubwayIcon, SuitcaseAltIcon, SuitcaseIcon, SunIcon, SunsetIcon, SurpriseIcon, SwatchbookIcon, SwiggyIcon, SwimmerIcon, SyncExclamationIcon, SyncIcon, SyncSlashIcon, SyringeIcon, TableIcon, TableTennisIcon, TabletIcon, TabletsIcon, TachometerFastAltIcon, TachometerFastIcon, TagAltIcon, TagIcon, TapeIcon, TaxiIcon, TearIcon, TelegramAltIcon, TelegramIcon, TelescopeIcon, TemperatureEmptyIcon, TemperatureHalfIcon, TemperatureIcon, TemperatureMinusIcon, TemperaturePlusIcon, TemperatureQuarterIcon, TemperatureThreeQuarterIcon, TennisBallIcon, TextFieldsIcon, TextIcon, TextSizeIcon, TextStrikeThroughIcon, ThIcon, ThLargeIcon, ThSlashIcon, ThermometerIcon, ThumbsDownIcon, ThumbsUpIcon, ThunderstormIcon, ThunderstormMoonIcon, ThunderstormSunIcon, TicketIcon, TimesCircleIcon, TimesIcon, TimesSquareIcon, ToggleOffIcon, ToggleOnIcon, ToiletPaperIcon, TopArrowFromTopIcon, TopArrowToTopIcon, TornadoIcon, TrademarkCircleIcon, TrademarkIcon, TrafficBarrierIcon, TrafficLightIcon, TransactionIcon, TrashAltIcon, TrashIcon, TreesIcon, TriangleIcon, TrophyIcon, TrowelIcon, TruckIcon, TruckLoadingIcon, TumblrAltIcon, TumblrIcon, TumblrSquareIcon, TvRetroIcon, TvRetroSlashIcon, TwitterAltIcon, TwitterIcon, UmbrellaIcon, UnamusedIcon, UnderlineIcon, UniversityIcon, UnlockAltIcon, UnlockIcon, UploadAltIcon, UploadIcon, UsdCircleIcon, UsdSquareIcon, UserArrowsIcon, UserCheckIcon, UserCircleIcon, UserExclamationIcon, UserIcon, UserLocationIcon, UserMdIcon, UserMinusIcon, UserNurseIcon, UserPlusIcon, UserSquareIcon, UserTimesIcon, UsersAltIcon, UtensilsAltIcon, UtensilsIcon, VectorSquareAltIcon, VectorSquareIcon, VenusIcon, VerticalAlignBottomIcon, VerticalAlignCenterIcon, VerticalAlignTopIcon, VerticalDistributeBottomIcon, VerticalDistributionCenterIcon, VerticalDistributionTopIcon, VideoIcon, VideoSlashIcon, VirusSlashIcon, VisualStudioIcon, VkAltIcon, VkIcon, VoicemailIcon, VoicemailRectangleIcon, VolumeDownIcon, VolumeIcon, VolumeMuteIcon, VolumeOffIcon, VolumeUpIcon, VuejsAltIcon, VuejsIcon, WallIcon, WalletIcon, WatchAltIcon, WatchIcon, WaterDropSlashIcon, WaterGlassIcon, WaterIcon, WebGridAltIcon, WebGridIcon, WebSectionAltIcon, WebSectionIcon, WebcamIcon, WeightIcon, WhatsappAltIcon, WhatsappIcon, WheelBarrowIcon, WheelchairAltIcon, WheelchairIcon, WifiIcon, WifiRouterIcon, WifiSlashIcon, WindIcon, WindMoonIcon, WindSunIcon, WindowGridIcon, WindowIcon, WindowMaximizeIcon, WindowSectionIcon, WindsockIcon, WindyIcon, WordpressIcon, WordpressSimpleIcon, WrapTextIcon, WrenchIcon, XAddIcon, XIcon, YenCircleIcon, YenIcon, YinYangIcon, YoutubeIcon };
//# sourceMappingURL=index.js.map
